/* =========================================================
   PORTS
   8 major global ports used for IMO compliance routing
   ========================================================= */

export const ports = [
  {'id': 'Shanghai', 'name': 'Shanghai', 'position': [31.405663, 121.544666]},
 {'id': 'Singapore', 'name': 'Singapore', 'position': [1.278771, 103.756599]},
 {'id': 'Rotterdam', 'name': 'Rotterdam', 'position': [51.944424, 4.168453]},
 {'id': 'Antwerpen', 'name': 'Antwerpen', 'position': [51.22472, 4.327261]},
 {'id': 'Long Beach',
  'name': 'Long Beach',
  'position': [33.743188, -118.214062]},
 {'id': 'Busan', 'name': 'Busan', 'position': [35.13, 129.05]},
 {'id': 'Jebel Ali', 'name': 'Jebel Ali', 'position': [25.024675, 55.039722]},
 {'id': 'Hamburg', 'name': 'Hamburg', 'position': [53.55, 9.93333]},
 {'id': 'Sydney', 'name': 'Sydney', 'position': [-33.857159, 151.235733]},
 {'id': 'Santos', 'name': 'Santos', 'position': [-23.980627, -46.337663]},
 {'id': 'New York', 'name': 'New York', 'position': [40.7, -74.01]},
 {'id': 'Nhava Sheva',
  'name': 'Nhava Sheva',
  'position': [18.973669, 72.944412]},
 {'id': 'Durban', 'name': 'Durban', 'position': [-29.864237, 31.059373]},
 {'id': 'San Antonio',
  'name': 'San Antonio',
  'position': [-33.583731, -71.625913]},
 {'id': 'Valencia', 'name': 'Valencia', 'position': [39.425785, -0.295]},
 {'id': 'Cartagena', 'name': 'Cartagena', 'position': [10.358489, -75.572033]},
 {'id': 'Algeciras', 'name': 'Algeciras', 'position': [36.139887, -5.420595]},
 {'id': 'Casablanca', 'name': 'Casablanca', 'position': [33.616989, -7.590487]},
 {'id': 'Las Palmas', 'name': 'Las Palmas', 'position': [28.126724, -15.413197]},
 {'id': 'Porto Du Acu',
  'name': 'Porto Du Acu',
  'position': [-21.844461, -40.973197]},
 {'id': 'Callao', 'name': 'Callao', 'position': [-12.049321, -77.159005]},
 {'id': 'Balboa', 'name': 'Balboa', 'position': [8.956954, -79.562924]},
 {'id': 'Tuticorin', 'name': 'Tuticorin', 'position': [8.751147, 78.218279]},
 {'id': 'Colombo', 'name': 'Colombo', 'position': [6.967749, 79.843912]}


];

/* =========================================================
   MARITIME ROUTES
   - Oceanic paths only
   - No continent crossing
   - No Panama / Suez canal shortcuts
   ========================================================= */

export const connections = [
  /* ── NORTH EUROPE (Coastal) ───────────────────────── */
  {'id': '_Shanghai->Singapore_',
  'from': 'Shanghai',
  'to': 'Singapore',
  'distance': 2206.6781857451406,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[31.405663, 121.544666],
   [31.296214, 121.77907],
   [30.929499, 122.870677],
   [28.315245, 122.301208],
   [2.296991, 104.802635],
   [1.508694, 104.543718],
   [1.318161, 104.317166],
   [1.135403, 103.735802],
   [1.18334, 103.668675],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Shanghai->Rotterdam_',
  'from': 'Shanghai',
  'to': 'Rotterdam',
  'distance': 10589.612850971922,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[31.405663, 121.544666],
   [31.296214, 121.77907],
   [30.929499, 122.870677],
   [28.315245, 122.301208],
   [2.296991, 104.802635],
   [1.508694, 104.543718],
   [1.318161, 104.317166],
   [1.135403, 103.735802],
   [1.281086, 103.274421],
   [1.922056, 102.214665],
   [2.618388, 101.378225],
   [5.467016, 98.007266],
   [6.314776, 93.822642],
   [5.740204, 79.87949],
   [14.395023, 53.015171],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [37.44674, 11.11313],
   [37.687752, 8.778707],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.762514, -9.095293],
   [36.969759, -9.375811],
   [38.659776, -10.015606],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_Shanghai->Antwerpen_',
  'from': 'Shanghai',
  'to': 'Antwerpen',
  'distance': 10580.7813174946,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[31.405663, 121.544666],
   [31.296214, 121.77907],
   [30.929499, 122.870677],
   [28.315245, 122.301208],
   [2.296991, 104.802635],
   [1.508694, 104.543718],
   [1.318161, 104.317166],
   [1.135403, 103.735802],
   [1.281086, 103.274421],
   [1.922056, 102.214665],
   [2.618388, 101.378225],
   [5.467016, 98.007266],
   [6.314776, 93.822642],
   [5.740204, 79.87949],
   [14.395023, 53.015171],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [37.44674, 11.11313],
   [37.687752, 8.778707],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.762514, -9.095293],
   [36.969759, -9.375811],
   [38.659776, -10.015606],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.985054, 1.491261],
   [51.358673, 2.499172],
   [51.352547, 2.947911],
   [51.421738, 3.519379],
   [51.422429, 3.612437],
   [51.22472, 4.327261]]},
 {'id': '_Shanghai->Long Beach_',
  'from': 'Shanghai',
  'to': 'Long Beach',
  'distance': 5738.004859611231,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[31.405663, 121.544666],
   [31.296214, 121.77907],
   [31.234738, 122.098721],
   [31.249769, 122.504677],
   [33.486608, 126.29831],
   [34.673714, 128.649957],
   [41.571973, 140.766683],
   [41.62252, 141.013059],
   [41.626027, 143.334973],
   [44.871556, 154.068314],
   [35.307074, -127.540709],
   [34.06766, -119.261942],
   [33.627136, -118.336854],
   [33.657073, -118.202901],
   [33.719161, -118.208295],
   [33.743188, -118.214062]]},
 {'id': '_Shanghai->Busan_',
  'from': 'Shanghai',
  'to': 'Busan',
  'distance': 461.06047516198703,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[31.405663, 121.544666],
   [31.296214, 121.77907],
   [31.234738, 122.098721],
   [31.249769, 122.504677],
   [33.486608, 126.29831],
   [34.673714, 128.649957],
   [34.751228, 128.768227],
   [35.026208, 129.090675],
   [35.066443, 129.114848],
   [35.110908, 129.057511],
   [35.13, 129.05]]},
 {'id': '_Singapore->Rotterdam_',
  'from': 'Singapore',
  'to': 'Rotterdam',
  'distance': 8397.350971922246,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[1.278771, 103.756599],
   [1.272622, 103.748388],
   [1.202515, 103.625522],
   [1.219293, 103.539816],
   [1.281086, 103.274421],
   [1.922056, 102.214665],
   [2.618388, 101.378225],
   [5.467016, 98.007266],
   [6.314776, 93.822642],
   [5.740204, 79.87949],
   [14.395023, 53.015171],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [37.44674, 11.11313],
   [37.687752, 8.778707],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.762514, -9.095293],
   [36.969759, -9.375811],
   [38.659776, -10.015606],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_Singapore->Jebel Ali_',
  'from': 'Singapore',
  'to': 'Jebel Ali',
  'distance': 3494.8277537796976,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[1.278771, 103.756599],
   [1.272622, 103.748388],
   [1.202515, 103.625522],
   [1.219293, 103.539816],
   [1.281086, 103.274421],
   [1.922056, 102.214665],
   [2.618388, 101.378225],
   [5.467016, 98.007266],
   [6.314776, 93.822642],
   [5.740204, 79.87949],
   [8.461506, 76.225885],
   [25.610655, 57.159535],
   [26.421797, 56.61533],
   [26.450409, 56.595042],
   [26.556975, 56.519435],
   [26.349851, 56.107086],
   [25.802904, 55.624014],
   [25.152555, 54.888019],
   [25.024675, 55.039722]]},
 {'id': '_Singapore->Hamburg_',
  'from': 'Singapore',
  'to': 'Hamburg',
  'distance': 8662.224082073433,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[1.278771, 103.756599],
   [1.272622, 103.748388],
   [1.202515, 103.625522],
   [1.219293, 103.539816],
   [1.281086, 103.274421],
   [1.922056, 102.214665],
   [2.618388, 101.378225],
   [5.467016, 98.007266],
   [6.314776, 93.822642],
   [5.740204, 79.87949],
   [14.395023, 53.015171],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [37.44674, 11.11313],
   [37.687752, 8.778707],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.762514, -9.095293],
   [36.969759, -9.375811],
   [38.659776, -10.015606],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [52.451839, 3.598474],
   [53.374134, 4.774132],
   [53.435702, 4.857545],
   [53.754149, 6.338944],
   [53.983932, 8.241397],
   [53.944442, 8.628174],
   [53.871762, 8.760262],
   [53.844426, 8.852273],
   [53.875507, 9.108048],
   [53.863158, 9.286919],
   [53.816161, 9.358502],
   [53.752061, 9.413777],
   [53.710019, 9.49154],
   [53.624893, 9.54527],
   [53.571207, 9.662],
   [53.547959, 9.849454],
   [53.55, 9.93333]]},
 {'id': '_Singapore->Sydney_',
  'from': 'Singapore',
  'to': 'Sydney',
  'distance': 4148.220842332614,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[1.278771, 103.756599],
   [1.272622, 103.748388],
   [1.18334, 103.668675],
   [1.135403, 103.735802],
   [1.26696, 104.216299],
   [1.272809, 104.585098],
   [-3.28061, 110.253849],
   [-5.757573, 119.614413],
   [-5.702597, 120.493476],
   [-8.065375, 125.682777],
   [-10.487699, 142.23128],
   [-10.511272, 142.375123],
   [-10.638531, 142.598079],
   [-10.824612, 142.823432],
   [-24.487609, 153.609237],
   [-27.167367, 153.877744],
   [-28.927625, 153.801028],
   [-30.427247, 153.446216],
   [-31.520752, 153.15853],
   [-32.666212, 152.640697],
   [-34.03591, 151.403649],
   [-33.857159, 151.235733]]},
 {'id': '_Singapore->Santos_',
  'from': 'Singapore',
  'to': 'Santos',
  'distance': 8967.586393088553,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[1.278771, 103.756599],
   [1.272622, 103.748388],
   [1.18334, 103.668675],
   [0.878661, 103.597977],
   [0.721348, 103.631241],
   [0.624711, 103.756654],
   [-0.674341, 104.173798],
   [-1.06357, 104.51003],
   [-2.095235, 105.063824],
   [-2.279399, 105.319145],
   [-2.377311, 105.642791],
   [-2.834436, 105.912496],
   [-3.128016, 106.315256],
   [-5.442629, 105.97363],
   [-5.920829, 105.802342],
   [-5.961821, 105.775402],
   [-34.614678, 26.147049],
   [-35.124225, 19.591451],
   [-27.422222, -40.459612],
   [-24.039835, -46.331067],
   [-23.9946, -46.3299],
   [-23.980627, -46.337663]]},
 {'id': '_Busan->Long Beach_',
  'from': 'Busan',
  'to': 'Long Beach',
  'distance': 5286.6906047516195,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[35.13, 129.05],
   [35.110908, 129.057511],
   [35.077889, 129.125237],
   [41.571973, 140.766683],
   [41.62252, 141.013059],
   [41.626027, 143.334973],
   [44.871556, 154.068314],
   [35.307074, -127.540709],
   [34.06766, -119.261942],
   [33.627136, -118.336854],
   [33.657073, -118.202901],
   [33.719161, -118.208295],
   [33.743188, -118.214062]]},
 {'id': '_Busan->Shanghai_',
  'from': 'Busan',
  'to': 'Shanghai',
  'distance': 461.06047516198703,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[35.13, 129.05],
   [35.110908, 129.057511],
   [35.066443, 129.114848],
   [35.026208, 129.090675],
   [34.751228, 128.768227],
   [34.673714, 128.649957],
   [33.486608, 126.29831],
   [31.249769, 122.504677],
   [31.234738, 122.098721],
   [31.296214, 121.77907],
   [31.405663, 121.544666]]},
 {'id': '_Busan->Singapore_',
  'from': 'Busan',
  'to': 'Singapore',
  'distance': 2525.8450323974084,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[35.13, 129.05],
   [35.110908, 129.057511],
   [35.066443, 129.114848],
   [35.026208, 129.090675],
   [34.751228, 128.768227],
   [34.673714, 128.649957],
   [33.486608, 126.29831],
   [31.596109, 124.006461],
   [25.251652, 120.204782],
   [2.296991, 104.802635],
   [1.508694, 104.543718],
   [1.318161, 104.317166],
   [1.135403, 103.735802],
   [1.18334, 103.668675],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Busan->New York_',
  'from': 'Busan',
  'to': 'New York',
  'distance': 10151.696004319654,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[35.13, 129.05],
   [35.110908, 129.057511],
   [35.077889, 129.125237],
   [41.571973, 140.766683],
   [41.62252, 141.013059],
   [41.626027, 143.334973],
   [44.871556, 154.068314],
   [33.312777, -126.44551],
   [17.990253, -104.085388],
   [6.887666, -81.918415],
   [6.976505, -80.225731],
   [7.721903, -79.44898],
   [8.761358, -79.44047],
   [8.924378, -79.548307],
   [8.93049, -79.5521],
   [8.945524, -79.567771],
   [8.958615, -79.571032],
   [8.990627, -79.585967],
   [9.00065, -79.596123],
   [9.016395, -79.612386],
   [9.02188, -79.619039],
   [9.026165, -79.626555],
   [9.036118, -79.639835],
   [9.036662, -79.640561],
   [9.04102, -79.64537],
   [9.057248, -79.657177],
   [9.067839, -79.670776],
   [9.085343, -79.679082],
   [9.106707, -79.69162],
   [9.111162, -79.699224],
   [9.114387, -79.706631],
   [9.120886, -79.747636],
   [9.120047, -79.756717],
   [9.114721, -79.764943],
   [9.114721, -79.774246],
   [9.11962, -79.802032],
   [9.166948, -79.820004],
   [9.180535, -79.841254],
   [9.184209, -79.845106],
   [9.183468, -79.857655],
   [9.183828, -79.874003],
   [9.213915, -79.927405],
   [9.247629, -79.923366],
   [9.26561, -79.924333],
   [9.280338, -79.922221],
   [9.31344, -79.919081],
   [9.354863, -79.921237],
   [9.395463, -79.916409],
   [20.038708, -74.014044],
   [20.413638, -73.991478],
   [20.532012, -74.014944],
   [22.508168, -73.290336],
   [24.207149, -73.002179],
   [35.086128, -73.661077],
   [40.424245, -73.912456],
   [40.53453, -74.009486],
   [40.637508, -74.05304],
   [40.661873, -74.046937],
   [40.701812, -74.024466],
   [40.7, -74.01]]},
 {'id': '_Rotterdam->Shanghai_',
  'from': 'Rotterdam',
  'to': 'Shanghai',
  'distance': 10595.213282937366,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[51.944424, 4.168453],
   [52.0223, 4.07924],
   [51.844907, 3.061935],
   [51.757716, 2.668369],
   [51.713796, 2.530332],
   [50.99019, 1.480863],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [43.249448, -9.976372],
   [38.659776, -10.015606],
   [36.939111, -9.296367],
   [36.549549, -8.948086],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [37.687752, 8.778707],
   [37.44674, 11.11313],
   [37.246558, 11.58653],
   [31.582408, 31.91037],
   [31.277831, 32.356823],
   [31.219657, 32.34349],
   [31.124555, 32.316018],
   [31.098968, 32.309581],
   [31.01215, 32.311948],
   [30.92644, 32.315036],
   [30.882132, 32.316759],
   [30.856494, 32.31736],
   [30.806851, 32.319086],
   [30.72762, 32.340148],
   [30.716357, 32.343279],
   [30.702928, 32.343279],
   [30.615521, 32.32242],
   [30.584149, 32.307437],
   [30.573949, 32.305024],
   [30.567006, 32.305024],
   [30.549151, 32.310662],
   [30.516402, 32.33589],
   [30.450646, 32.351865],
   [30.409672, 32.364669],
   [30.311204, 32.403937],
   [30.270088, 32.474408],
   [30.261655, 32.49956],
   [30.255677, 32.515638],
   [30.220606, 32.55175],
   [30.185167, 32.568513],
   [30.062236, 32.571277],
   [29.981319, 32.585869],
   [29.968325, 32.586297],
   [29.95763, 32.58404],
   [29.942011, 32.574572],
   [29.925542, 32.558253],
   [29.919799, 32.556124],
   [29.594995, 32.575619],
   [28.515487, 33.045805],
   [27.987629, 33.505678],
   [27.391654, 34.218474],
   [13.552195, 42.612244],
   [13.200887, 43.024293],
   [12.756687, 43.27156],
   [12.624003, 43.384199],
   [12.551471, 43.528042],
   [12.425076, 43.911623],
   [12.116767, 44.974885],
   [14.380255, 53.237559],
   [5.539799, 81.030231],
   [6.255202, 94.944615],
   [5.467016, 98.007266],
   [2.618388, 101.378225],
   [1.922056, 102.214665],
   [1.279813, 103.412156],
   [1.219293, 103.539816],
   [1.135403, 103.735802],
   [1.318161, 104.317166],
   [1.508694, 104.543718],
   [22.835274, 117.229707],
   [25.251652, 120.204782],
   [30.389278, 122.912816],
   [30.929499, 122.870677],
   [31.296214, 121.77907],
   [31.405663, 121.544666]]},
 {'id': '_Rotterdam->Singapore_',
  'from': 'Rotterdam',
  'to': 'Singapore',
  'distance': 8398.656047516199,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[51.944424, 4.168453],
   [52.0223, 4.07924],
   [51.844907, 3.061935],
   [51.757716, 2.668369],
   [51.713796, 2.530332],
   [50.99019, 1.480863],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [43.249448, -9.976372],
   [38.659776, -10.015606],
   [36.939111, -9.296367],
   [36.549549, -8.948086],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [37.687752, 8.778707],
   [37.44674, 11.11313],
   [37.246558, 11.58653],
   [31.582408, 31.91037],
   [31.277831, 32.356823],
   [31.219657, 32.34349],
   [31.124555, 32.316018],
   [31.098968, 32.309581],
   [31.01215, 32.311948],
   [30.92644, 32.315036],
   [30.882132, 32.316759],
   [30.856494, 32.31736],
   [30.806851, 32.319086],
   [30.72762, 32.340148],
   [30.716357, 32.343279],
   [30.702928, 32.343279],
   [30.615521, 32.32242],
   [30.584149, 32.307437],
   [30.573949, 32.305024],
   [30.567006, 32.305024],
   [30.549151, 32.310662],
   [30.516402, 32.33589],
   [30.450646, 32.351865],
   [30.409672, 32.364669],
   [30.311204, 32.403937],
   [30.270088, 32.474408],
   [30.261655, 32.49956],
   [30.255677, 32.515638],
   [30.220606, 32.55175],
   [30.185167, 32.568513],
   [30.062236, 32.571277],
   [29.981319, 32.585869],
   [29.968325, 32.586297],
   [29.95763, 32.58404],
   [29.942011, 32.574572],
   [29.925542, 32.558253],
   [29.919799, 32.556124],
   [29.594995, 32.575619],
   [28.515487, 33.045805],
   [27.987629, 33.505678],
   [27.391654, 34.218474],
   [13.552195, 42.612244],
   [13.200887, 43.024293],
   [12.756687, 43.27156],
   [12.624003, 43.384199],
   [12.551471, 43.528042],
   [12.425076, 43.911623],
   [12.116767, 44.974885],
   [14.380255, 53.237559],
   [5.539799, 81.030231],
   [6.255202, 94.944615],
   [5.467016, 98.007266],
   [2.618388, 101.378225],
   [1.922056, 102.214665],
   [1.279813, 103.412156],
   [1.219293, 103.539816],
   [1.202515, 103.625522],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Rotterdam->Jebel Ali_',
  'from': 'Rotterdam',
  'to': 'Jebel Ali',
  'distance': 6291.2138228941685,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[51.944424, 4.168453],
   [52.0223, 4.07924],
   [51.844907, 3.061935],
   [51.757716, 2.668369],
   [51.713796, 2.530332],
   [50.99019, 1.480863],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [43.249448, -9.976372],
   [38.659776, -10.015606],
   [36.939111, -9.296367],
   [36.549549, -8.948086],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [37.687752, 8.778707],
   [37.44674, 11.11313],
   [37.246558, 11.58653],
   [31.582408, 31.91037],
   [31.277831, 32.356823],
   [31.219657, 32.34349],
   [31.124555, 32.316018],
   [31.098968, 32.309581],
   [31.01215, 32.311948],
   [30.92644, 32.315036],
   [30.882132, 32.316759],
   [30.856494, 32.31736],
   [30.806851, 32.319086],
   [30.72762, 32.340148],
   [30.716357, 32.343279],
   [30.702928, 32.343279],
   [30.615521, 32.32242],
   [30.584149, 32.307437],
   [30.573949, 32.305024],
   [30.567006, 32.305024],
   [30.549151, 32.310662],
   [30.516402, 32.33589],
   [30.450646, 32.351865],
   [30.409672, 32.364669],
   [30.311204, 32.403937],
   [30.270088, 32.474408],
   [30.261655, 32.49956],
   [30.255677, 32.515638],
   [30.220606, 32.55175],
   [30.185167, 32.568513],
   [30.062236, 32.571277],
   [29.981319, 32.585869],
   [29.968325, 32.586297],
   [29.95763, 32.58404],
   [29.942011, 32.574572],
   [29.925542, 32.558253],
   [29.919799, 32.556124],
   [29.594995, 32.575619],
   [28.515487, 33.045805],
   [27.987629, 33.505678],
   [27.391654, 34.218474],
   [13.552195, 42.612244],
   [13.200887, 43.024293],
   [12.756687, 43.27156],
   [12.624003, 43.384199],
   [12.551471, 43.528042],
   [12.425076, 43.911623],
   [12.116767, 44.974885],
   [14.631086, 53.039641],
   [18.311038, 57.498764],
   [19.835453, 58.857653],
   [20.558074, 59.493383],
   [22.418407, 59.982448],
   [22.840891, 59.882404],
   [25.610655, 57.159535],
   [26.421797, 56.61533],
   [26.450409, 56.595042],
   [26.556975, 56.519435],
   [26.349851, 56.107086],
   [25.802904, 55.624014],
   [25.152555, 54.888019],
   [25.024675, 55.039722]]},
 {'id': '_Rotterdam->New York_',
  'from': 'Rotterdam',
  'to': 'New York',
  'distance': 3290.848272138229,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[51.944424, 4.168453],
   [52.0223, 4.07924],
   [51.844907, 3.061935],
   [51.757716, 2.668369],
   [51.713796, 2.530332],
   [50.99019, 1.480863],
   [50.536371, 0.644132],
   [49.742779, -6.064875],
   [49.696953, -6.805386],
   [49.757071, -7.472542],
   [46.439659, -52.574212],
   [41.435904, -69.487495],
   [40.45093, -73.768613],
   [40.53453, -74.009486],
   [40.637508, -74.05304],
   [40.661873, -74.046937],
   [40.701812, -74.024466],
   [40.7, -74.01]]},
 {'id': '_Rotterdam->Santos_',
  'from': 'Rotterdam',
  'to': 'Santos',
  'distance': 5437.745140388769,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[51.944424, 4.168453],
   [52.0223, 4.07924],
   [51.844907, 3.061935],
   [51.757716, 2.668369],
   [51.713796, 2.530332],
   [50.99019, 1.480863],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [33.216694, -17.447004],
   [19.922556, -24.551329],
   [-3.044612, -32.794761],
   [-9.100541, -34.463595],
   [-18.069687, -38.483549],
   [-22.317603, -40.932471],
   [-23.067394, -41.932178],
   [-24.008632, -45.2037],
   [-24.069078, -46.276052],
   [-24.039835, -46.331067],
   [-23.9946, -46.3299],
   [-23.980627, -46.337663]]},
 {'id': '_Antwerpen->Santos_',
  'from': 'Antwerpen',
  'to': 'Santos',
  'distance': 5428.521058315335,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[51.22472, 4.327261],
   [51.422429, 3.612437],
   [51.421738, 3.519379],
   [51.351016, 2.786071],
   [51.358673, 2.499172],
   [50.985054, 1.491261],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [33.216694, -17.447004],
   [19.922556, -24.551329],
   [-3.044612, -32.794761],
   [-9.100541, -34.463595],
   [-18.069687, -38.483549],
   [-22.317603, -40.932471],
   [-23.067394, -41.932178],
   [-24.008632, -45.2037],
   [-24.069078, -46.276052],
   [-24.039835, -46.331067],
   [-23.9946, -46.3299],
   [-23.980627, -46.337663]]},
 {'id': '_Antwerpen->Shanghai_',
  'from': 'Antwerpen',
  'to': 'Shanghai',
  'distance': 10585.988660907127,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[51.22472, 4.327261],
   [51.422429, 3.612437],
   [51.421738, 3.519379],
   [51.351016, 2.786071],
   [51.358673, 2.499172],
   [50.985054, 1.491261],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [43.249448, -9.976372],
   [38.659776, -10.015606],
   [36.939111, -9.296367],
   [36.549549, -8.948086],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [37.687752, 8.778707],
   [37.44674, 11.11313],
   [37.246558, 11.58653],
   [31.582408, 31.91037],
   [31.277831, 32.356823],
   [31.219657, 32.34349],
   [31.124555, 32.316018],
   [31.098968, 32.309581],
   [31.01215, 32.311948],
   [30.92644, 32.315036],
   [30.882132, 32.316759],
   [30.856494, 32.31736],
   [30.806851, 32.319086],
   [30.72762, 32.340148],
   [30.716357, 32.343279],
   [30.702928, 32.343279],
   [30.615521, 32.32242],
   [30.584149, 32.307437],
   [30.573949, 32.305024],
   [30.567006, 32.305024],
   [30.549151, 32.310662],
   [30.516402, 32.33589],
   [30.450646, 32.351865],
   [30.409672, 32.364669],
   [30.311204, 32.403937],
   [30.270088, 32.474408],
   [30.261655, 32.49956],
   [30.255677, 32.515638],
   [30.220606, 32.55175],
   [30.185167, 32.568513],
   [30.062236, 32.571277],
   [29.981319, 32.585869],
   [29.968325, 32.586297],
   [29.95763, 32.58404],
   [29.942011, 32.574572],
   [29.925542, 32.558253],
   [29.919799, 32.556124],
   [29.594995, 32.575619],
   [28.515487, 33.045805],
   [27.987629, 33.505678],
   [27.391654, 34.218474],
   [13.552195, 42.612244],
   [13.200887, 43.024293],
   [12.756687, 43.27156],
   [12.624003, 43.384199],
   [12.551471, 43.528042],
   [12.425076, 43.911623],
   [12.116767, 44.974885],
   [14.380255, 53.237559],
   [5.539799, 81.030231],
   [6.255202, 94.944615],
   [5.467016, 98.007266],
   [2.618388, 101.378225],
   [1.922056, 102.214665],
   [1.279813, 103.412156],
   [1.219293, 103.539816],
   [1.135403, 103.735802],
   [1.318161, 104.317166],
   [1.508694, 104.543718],
   [22.835274, 117.229707],
   [25.251652, 120.204782],
   [30.389278, 122.912816],
   [30.929499, 122.870677],
   [31.296214, 121.77907],
   [31.405663, 121.544666]]},
 {'id': '_Antwerpen->Singapore_',
  'from': 'Antwerpen',
  'to': 'Singapore',
  'distance': 8389.431965442765,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[51.22472, 4.327261],
   [51.422429, 3.612437],
   [51.421738, 3.519379],
   [51.351016, 2.786071],
   [51.358673, 2.499172],
   [50.985054, 1.491261],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [43.249448, -9.976372],
   [38.659776, -10.015606],
   [36.939111, -9.296367],
   [36.549549, -8.948086],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [37.687752, 8.778707],
   [37.44674, 11.11313],
   [37.246558, 11.58653],
   [31.582408, 31.91037],
   [31.277831, 32.356823],
   [31.219657, 32.34349],
   [31.124555, 32.316018],
   [31.098968, 32.309581],
   [31.01215, 32.311948],
   [30.92644, 32.315036],
   [30.882132, 32.316759],
   [30.856494, 32.31736],
   [30.806851, 32.319086],
   [30.72762, 32.340148],
   [30.716357, 32.343279],
   [30.702928, 32.343279],
   [30.615521, 32.32242],
   [30.584149, 32.307437],
   [30.573949, 32.305024],
   [30.567006, 32.305024],
   [30.549151, 32.310662],
   [30.516402, 32.33589],
   [30.450646, 32.351865],
   [30.409672, 32.364669],
   [30.311204, 32.403937],
   [30.270088, 32.474408],
   [30.261655, 32.49956],
   [30.255677, 32.515638],
   [30.220606, 32.55175],
   [30.185167, 32.568513],
   [30.062236, 32.571277],
   [29.981319, 32.585869],
   [29.968325, 32.586297],
   [29.95763, 32.58404],
   [29.942011, 32.574572],
   [29.925542, 32.558253],
   [29.919799, 32.556124],
   [29.594995, 32.575619],
   [28.515487, 33.045805],
   [27.987629, 33.505678],
   [27.391654, 34.218474],
   [13.552195, 42.612244],
   [13.200887, 43.024293],
   [12.756687, 43.27156],
   [12.624003, 43.384199],
   [12.551471, 43.528042],
   [12.425076, 43.911623],
   [12.116767, 44.974885],
   [14.380255, 53.237559],
   [5.539799, 81.030231],
   [6.255202, 94.944615],
   [5.467016, 98.007266],
   [2.618388, 101.378225],
   [1.922056, 102.214665],
   [1.279813, 103.412156],
   [1.219293, 103.539816],
   [1.202515, 103.625522],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Antwerpen->New York_',
  'from': 'Antwerpen',
  'to': 'New York',
  'distance': 3281.6436285097193,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[51.22472, 4.327261],
   [51.422429, 3.612437],
   [51.421738, 3.519379],
   [51.351016, 2.786071],
   [51.358673, 2.499172],
   [50.985054, 1.491261],
   [50.536371, 0.644132],
   [49.742779, -6.064875],
   [49.696953, -6.805386],
   [49.757071, -7.472542],
   [46.439659, -52.574212],
   [41.435904, -69.487495],
   [40.45093, -73.768613],
   [40.53453, -74.009486],
   [40.637508, -74.05304],
   [40.661873, -74.046937],
   [40.701812, -74.024466],
   [40.7, -74.01]]},
 {'id': '_Hamburg->Shanghai_',
  'from': 'Hamburg',
  'to': 'Shanghai',
  'distance': 10860.149568034558,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[53.55, 9.93333],
   [53.547959, 9.849454],
   [53.571207, 9.662],
   [53.624893, 9.54527],
   [53.710019, 9.49154],
   [53.752061, 9.413777],
   [53.816161, 9.358502],
   [53.863158, 9.286919],
   [53.875507, 9.108048],
   [53.844426, 8.852273],
   [53.871762, 8.760262],
   [53.944442, 8.628174],
   [53.993596, 8.187102],
   [53.754149, 6.338944],
   [53.435702, 4.857545],
   [53.317264, 4.641315],
   [52.451839, 3.598474],
   [50.99019, 1.480863],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [43.249448, -9.976372],
   [38.659776, -10.015606],
   [36.939111, -9.296367],
   [36.549549, -8.948086],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [37.687752, 8.778707],
   [37.44674, 11.11313],
   [37.246558, 11.58653],
   [31.582408, 31.91037],
   [31.277831, 32.356823],
   [31.219657, 32.34349],
   [31.124555, 32.316018],
   [31.098968, 32.309581],
   [31.01215, 32.311948],
   [30.92644, 32.315036],
   [30.882132, 32.316759],
   [30.856494, 32.31736],
   [30.806851, 32.319086],
   [30.72762, 32.340148],
   [30.716357, 32.343279],
   [30.702928, 32.343279],
   [30.615521, 32.32242],
   [30.584149, 32.307437],
   [30.573949, 32.305024],
   [30.567006, 32.305024],
   [30.549151, 32.310662],
   [30.516402, 32.33589],
   [30.450646, 32.351865],
   [30.409672, 32.364669],
   [30.311204, 32.403937],
   [30.270088, 32.474408],
   [30.261655, 32.49956],
   [30.255677, 32.515638],
   [30.220606, 32.55175],
   [30.185167, 32.568513],
   [30.062236, 32.571277],
   [29.981319, 32.585869],
   [29.968325, 32.586297],
   [29.95763, 32.58404],
   [29.942011, 32.574572],
   [29.925542, 32.558253],
   [29.919799, 32.556124],
   [29.594995, 32.575619],
   [28.515487, 33.045805],
   [27.987629, 33.505678],
   [27.391654, 34.218474],
   [13.552195, 42.612244],
   [13.200887, 43.024293],
   [12.756687, 43.27156],
   [12.624003, 43.384199],
   [12.551471, 43.528042],
   [12.425076, 43.911623],
   [12.116767, 44.974885],
   [14.380255, 53.237559],
   [5.539799, 81.030231],
   [6.255202, 94.944615],
   [5.467016, 98.007266],
   [2.618388, 101.378225],
   [1.922056, 102.214665],
   [1.279813, 103.412156],
   [1.219293, 103.539816],
   [1.135403, 103.735802],
   [1.318161, 104.317166],
   [1.508694, 104.543718],
   [22.835274, 117.229707],
   [25.251652, 120.204782],
   [30.389278, 122.912816],
   [30.929499, 122.870677],
   [31.296214, 121.77907],
   [31.405663, 121.544666]]},
 {'id': '_Hamburg->Singapore_',
  'from': 'Hamburg',
  'to': 'Singapore',
  'distance': 8663.59233261339,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[53.55, 9.93333],
   [53.547959, 9.849454],
   [53.571207, 9.662],
   [53.624893, 9.54527],
   [53.710019, 9.49154],
   [53.752061, 9.413777],
   [53.816161, 9.358502],
   [53.863158, 9.286919],
   [53.875507, 9.108048],
   [53.844426, 8.852273],
   [53.871762, 8.760262],
   [53.944442, 8.628174],
   [53.993596, 8.187102],
   [53.754149, 6.338944],
   [53.435702, 4.857545],
   [53.317264, 4.641315],
   [52.451839, 3.598474],
   [50.99019, 1.480863],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [43.249448, -9.976372],
   [38.659776, -10.015606],
   [36.939111, -9.296367],
   [36.549549, -8.948086],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [37.687752, 8.778707],
   [37.44674, 11.11313],
   [37.246558, 11.58653],
   [31.582408, 31.91037],
   [31.277831, 32.356823],
   [31.219657, 32.34349],
   [31.124555, 32.316018],
   [31.098968, 32.309581],
   [31.01215, 32.311948],
   [30.92644, 32.315036],
   [30.882132, 32.316759],
   [30.856494, 32.31736],
   [30.806851, 32.319086],
   [30.72762, 32.340148],
   [30.716357, 32.343279],
   [30.702928, 32.343279],
   [30.615521, 32.32242],
   [30.584149, 32.307437],
   [30.573949, 32.305024],
   [30.567006, 32.305024],
   [30.549151, 32.310662],
   [30.516402, 32.33589],
   [30.450646, 32.351865],
   [30.409672, 32.364669],
   [30.311204, 32.403937],
   [30.270088, 32.474408],
   [30.261655, 32.49956],
   [30.255677, 32.515638],
   [30.220606, 32.55175],
   [30.185167, 32.568513],
   [30.062236, 32.571277],
   [29.981319, 32.585869],
   [29.968325, 32.586297],
   [29.95763, 32.58404],
   [29.942011, 32.574572],
   [29.925542, 32.558253],
   [29.919799, 32.556124],
   [29.594995, 32.575619],
   [28.515487, 33.045805],
   [27.987629, 33.505678],
   [27.391654, 34.218474],
   [13.552195, 42.612244],
   [13.200887, 43.024293],
   [12.756687, 43.27156],
   [12.624003, 43.384199],
   [12.551471, 43.528042],
   [12.425076, 43.911623],
   [12.116767, 44.974885],
   [14.380255, 53.237559],
   [5.539799, 81.030231],
   [6.255202, 94.944615],
   [5.467016, 98.007266],
   [2.618388, 101.378225],
   [1.922056, 102.214665],
   [1.279813, 103.412156],
   [1.219293, 103.539816],
   [1.202515, 103.625522],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Hamburg->Long Beach_',
  'from': 'Hamburg',
  'to': 'Long Beach',
  'distance': 8057.216522678185,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[53.55, 9.93333],
   [53.547959, 9.849454],
   [53.571207, 9.662],
   [53.624893, 9.54527],
   [53.710019, 9.49154],
   [53.752061, 9.413777],
   [53.816161, 9.358502],
   [53.863158, 9.286919],
   [53.875507, 9.108048],
   [53.844426, 8.852273],
   [53.871762, 8.760262],
   [53.944442, 8.628174],
   [53.993596, 8.187102],
   [53.754149, 6.338944],
   [53.435702, 4.857545],
   [53.317264, 4.641315],
   [52.451839, 3.598474],
   [50.99019, 1.480863],
   [50.536371, 0.644132],
   [49.402603, -7.285783],
   [20.825058, -65.826569],
   [17.954517, -68.259437],
   [9.733005, -79.654549],
   [9.395463, -79.916409],
   [9.354863, -79.921237],
   [9.31344, -79.919081],
   [9.280338, -79.922221],
   [9.26561, -79.924333],
   [9.247629, -79.923366],
   [9.213915, -79.927405],
   [9.183828, -79.874003],
   [9.183468, -79.857655],
   [9.184209, -79.845106],
   [9.180535, -79.841254],
   [9.166948, -79.820004],
   [9.11962, -79.802032],
   [9.114721, -79.774246],
   [9.114721, -79.764943],
   [9.119599, -79.755625],
   [9.120886, -79.747636],
   [9.114387, -79.706631],
   [9.111162, -79.699224],
   [9.106707, -79.69162],
   [9.085343, -79.679082],
   [9.067839, -79.670776],
   [9.057248, -79.657177],
   [9.04102, -79.64537],
   [9.036662, -79.640561],
   [9.036118, -79.639835],
   [9.026165, -79.626555],
   [9.02188, -79.619039],
   [9.016395, -79.612386],
   [9.00065, -79.596123],
   [8.990627, -79.585967],
   [8.958615, -79.571032],
   [8.945524, -79.567771],
   [8.928145, -79.549587],
   [8.908835, -79.545221],
   [8.823287, -79.483143],
   [8.716884, -79.425794],
   [7.721903, -79.44898],
   [6.976505, -80.225731],
   [6.887666, -81.918415],
   [17.990253, -104.085388],
   [23.879051, -112.203761],
   [27.762408, -115.476182],
   [29.485787, -116.32845],
   [33.657073, -118.202901],
   [33.719161, -118.208295],
   [33.743188, -118.214062]]},
 {'id': '_Hamburg->Jebel Ali_',
  'from': 'Hamburg',
  'to': 'Jebel Ali',
  'distance': 6556.1501079913605,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[53.55, 9.93333],
   [53.547959, 9.849454],
   [53.571207, 9.662],
   [53.624893, 9.54527],
   [53.710019, 9.49154],
   [53.752061, 9.413777],
   [53.816161, 9.358502],
   [53.863158, 9.286919],
   [53.875507, 9.108048],
   [53.844426, 8.852273],
   [53.871762, 8.760262],
   [53.944442, 8.628174],
   [53.993596, 8.187102],
   [53.754149, 6.338944],
   [53.435702, 4.857545],
   [53.317264, 4.641315],
   [52.451839, 3.598474],
   [50.99019, 1.480863],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [43.249448, -9.976372],
   [38.659776, -10.015606],
   [36.939111, -9.296367],
   [36.549549, -8.948086],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [37.687752, 8.778707],
   [37.44674, 11.11313],
   [37.246558, 11.58653],
   [31.582408, 31.91037],
   [31.277831, 32.356823],
   [31.219657, 32.34349],
   [31.124555, 32.316018],
   [31.098968, 32.309581],
   [31.01215, 32.311948],
   [30.92644, 32.315036],
   [30.882132, 32.316759],
   [30.856494, 32.31736],
   [30.806851, 32.319086],
   [30.72762, 32.340148],
   [30.716357, 32.343279],
   [30.702928, 32.343279],
   [30.615521, 32.32242],
   [30.584149, 32.307437],
   [30.573949, 32.305024],
   [30.567006, 32.305024],
   [30.549151, 32.310662],
   [30.516402, 32.33589],
   [30.450646, 32.351865],
   [30.409672, 32.364669],
   [30.311204, 32.403937],
   [30.270088, 32.474408],
   [30.261655, 32.49956],
   [30.255677, 32.515638],
   [30.220606, 32.55175],
   [30.185167, 32.568513],
   [30.062236, 32.571277],
   [29.981319, 32.585869],
   [29.968325, 32.586297],
   [29.95763, 32.58404],
   [29.942011, 32.574572],
   [29.925542, 32.558253],
   [29.919799, 32.556124],
   [29.594995, 32.575619],
   [28.515487, 33.045805],
   [27.987629, 33.505678],
   [27.391654, 34.218474],
   [13.552195, 42.612244],
   [13.200887, 43.024293],
   [12.756687, 43.27156],
   [12.624003, 43.384199],
   [12.551471, 43.528042],
   [12.425076, 43.911623],
   [12.116767, 44.974885],
   [14.631086, 53.039641],
   [18.311038, 57.498764],
   [19.835453, 58.857653],
   [20.558074, 59.493383],
   [22.418407, 59.982448],
   [22.840891, 59.882404],
   [25.610655, 57.159535],
   [26.421797, 56.61533],
   [26.450409, 56.595042],
   [26.556975, 56.519435],
   [26.349851, 56.107086],
   [25.802904, 55.624014],
   [25.152555, 54.888019],
   [25.024675, 55.039722]]},
 {'id': '_Jebel Ali->Singapore_',
  'from': 'Jebel Ali',
  'to': 'Singapore',
  'distance': 3499.6225701943845,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[25.024675, 55.039722],
   [25.152555, 54.888019],
   [25.293527, 55.077412],
   [26.392384, 56.137742],
   [26.556975, 56.519435],
   [26.450409, 56.595042],
   [26.40488, 56.688215],
   [25.610655, 57.159535],
   [6.388638, 78.460242],
   [5.539799, 81.030231],
   [6.255202, 94.944615],
   [5.467016, 98.007266],
   [2.618388, 101.378225],
   [1.922056, 102.214665],
   [1.279813, 103.412156],
   [1.219293, 103.539816],
   [1.202515, 103.625522],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Jebel Ali->Shanghai_',
  'from': 'Jebel Ali',
  'to': 'Shanghai',
  'distance': 5696.17980561555,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[25.024675, 55.039722],
   [25.152555, 54.888019],
   [25.293527, 55.077412],
   [26.392384, 56.137742],
   [26.556975, 56.519435],
   [26.450409, 56.595042],
   [26.40488, 56.688215],
   [25.610655, 57.159535],
   [6.388638, 78.460242],
   [5.539799, 81.030231],
   [6.255202, 94.944615],
   [5.467016, 98.007266],
   [2.618388, 101.378225],
   [1.922056, 102.214665],
   [1.279813, 103.412156],
   [1.219293, 103.539816],
   [1.135403, 103.735802],
   [1.318161, 104.317166],
   [1.508694, 104.543718],
   [22.835274, 117.229707],
   [25.251652, 120.204782],
   [30.389278, 122.912816],
   [30.929499, 122.870677],
   [31.296214, 121.77907],
   [31.405663, 121.544666]]},
 {'id': '_Jebel Ali->Rotterdam_',
  'from': 'Jebel Ali',
  'to': 'Rotterdam',
  'distance': 6293.167386609071,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[25.024675, 55.039722],
   [25.152555, 54.888019],
   [25.293527, 55.077412],
   [26.392384, 56.137742],
   [26.556975, 56.519435],
   [26.450409, 56.595042],
   [26.40488, 56.688215],
   [25.610655, 57.159535],
   [22.637636, 59.900937],
   [22.418407, 59.982448],
   [20.558074, 59.493383],
   [19.835453, 58.857653],
   [18.311038, 57.498764],
   [14.31341, 52.751169],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [37.44674, 11.11313],
   [37.687752, 8.778707],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.762514, -9.095293],
   [36.969759, -9.375811],
   [38.659776, -10.015606],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_Jebel Ali->Nhava Sheva_',
  'from': 'Jebel Ali',
  'to': 'Nhava Sheva',
  'distance': 1173.7289416846652,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[25.024675, 55.039722],
   [25.152555, 54.888019],
   [25.293527, 55.077412],
   [26.392384, 56.137742],
   [26.556975, 56.519435],
   [26.450409, 56.595042],
   [26.40488, 56.688215],
   [25.610655, 57.159535],
   [18.856973, 72.573479],
   [18.84336, 72.791641],
   [18.871719, 72.881542],
   [18.973669, 72.944412]]},
 {'id': '_Jebel Ali->Durban_',
  'from': 'Jebel Ali',
  'to': 'Durban',
  'distance': 4049.2235421166306,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[25.024675, 55.039722],
   [25.152555, 54.888019],
   [25.293527, 55.077412],
   [26.392384, 56.137742],
   [26.556975, 56.519435],
   [26.450409, 56.595042],
   [26.40488, 56.688215],
   [25.610655, 57.159535],
   [22.637636, 59.900937],
   [22.280244, 60.117446],
   [17.960183, 60.036389],
   [-15.733314, 41.046358],
   [-28.424591, 32.914952],
   [-29.17657, 32.069473],
   [-29.8526, 31.0637],
   [-29.864237, 31.059373]]},
 {'id': '_Long Beach->Shanghai_',
  'from': 'Long Beach',
  'to': 'Shanghai',
  'distance': 5736.345032397408,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[33.743188, -118.214062],
   [33.719161, -118.208295],
   [33.657073, -118.202901],
   [33.627136, -118.336854],
   [34.061373, -119.502187],
   [34.114366, -119.9261],
   [35.307074, -127.540709],
   [44.871556, 154.068314],
   [41.626027, 143.334973],
   [41.582751, 140.864849],
   [41.151196, 139.940285],
   [34.673714, 128.649957],
   [33.486608, 126.29831],
   [31.249769, 122.504677],
   [31.234738, 122.098721],
   [31.296214, 121.77907],
   [31.405663, 121.544666]]},
 {'id': '_Long Beach->Busan_',
  'from': 'Long Beach',
  'to': 'Busan',
  'distance': 5285.040496760259,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[33.743188, -118.214062],
   [33.719161, -118.208295],
   [33.657073, -118.202901],
   [33.627136, -118.336854],
   [34.061373, -119.502187],
   [34.114366, -119.9261],
   [35.307074, -127.540709],
   [44.871556, 154.068314],
   [41.626027, 143.334973],
   [41.582751, 140.864849],
   [41.151196, 139.940285],
   [35.077889, 129.125237],
   [35.110908, 129.057511],
   [35.13, 129.05]]},
 {'id': '_Long Beach->Singapore_',
  'from': 'Long Beach',
  'to': 'Singapore',
  'distance': 7781.5545356371495,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[33.743188, -118.214062],
   [33.719161, -118.208295],
   [33.657073, -118.202901],
   [33.627136, -118.336854],
   [34.061373, -119.502187],
   [34.114366, -119.9261],
   [34.774275, -127.245548],
   [37.923319, 147.907442],
   [34.649507, 139.78925],
   [34.607958, 139.267869],
   [30.495003, 129.931581],
   [22.835274, 117.229707],
   [1.508694, 104.543718],
   [1.318161, 104.317166],
   [1.135403, 103.735802],
   [1.18334, 103.668675],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Long Beach->Sydney_',
  'from': 'Long Beach',
  'to': 'Sydney',
  'distance': 6528.25323974082,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[33.743188, -118.214062],
   [33.719161, -118.208295],
   [33.657073, -118.202901],
   [33.544563, -118.549472],
   [30.575078, -124.981938],
   [-17.419801, -179.9285],
   [-19.174644, 177.827553],
   [-34.03591, 151.403649],
   [-33.857159, 151.235733]]},
 {'id': '_New York->Rotterdam_',
  'from': 'New York',
  'to': 'Rotterdam',
  'distance': 3293.124730021598,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[40.7, -74.01],
   [40.701812, -74.024466],
   [40.661873, -74.046937],
   [40.637508, -74.05304],
   [40.53453, -74.009486],
   [40.45093, -73.768613],
   [40.704831, -72.798065],
   [41.684158, -67.77493],
   [46.439659, -52.574212],
   [49.757071, -7.472542],
   [49.742779, -6.707331],
   [49.742779, -6.064875],
   [50.606854, 0.828873],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_New York->Antwerpen_',
  'from': 'New York',
  'to': 'Antwerpen',
  'distance': 3284.2931965442763,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[40.7, -74.01],
   [40.701812, -74.024466],
   [40.661873, -74.046937],
   [40.637508, -74.05304],
   [40.53453, -74.009486],
   [40.45093, -73.768613],
   [40.704831, -72.798065],
   [41.684158, -67.77493],
   [46.439659, -52.574212],
   [49.757071, -7.472542],
   [49.742779, -6.707331],
   [49.742779, -6.064875],
   [50.606854, 0.828873],
   [50.985054, 1.491261],
   [51.358673, 2.499172],
   [51.352547, 2.947911],
   [51.421738, 3.519379],
   [51.422429, 3.612437],
   [51.22472, 4.327261]]},
 {'id': '_New York->Hamburg_',
  'from': 'New York',
  'to': 'Hamburg',
  'distance': 3557.9978401727863,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[40.7, -74.01],
   [40.701812, -74.024466],
   [40.661873, -74.046937],
   [40.637508, -74.05304],
   [40.53453, -74.009486],
   [40.45093, -73.768613],
   [40.704831, -72.798065],
   [41.684158, -67.77493],
   [46.439659, -52.574212],
   [49.757071, -7.472542],
   [49.742779, -6.707331],
   [49.742779, -6.064875],
   [50.606854, 0.828873],
   [50.99019, 1.480863],
   [52.451839, 3.598474],
   [53.374134, 4.774132],
   [53.435702, 4.857545],
   [53.754149, 6.338944],
   [53.983932, 8.241397],
   [53.944442, 8.628174],
   [53.871762, 8.760262],
   [53.844426, 8.852273],
   [53.875507, 9.108048],
   [53.863158, 9.286919],
   [53.816161, 9.358502],
   [53.752061, 9.413777],
   [53.710019, 9.49154],
   [53.624893, 9.54527],
   [53.571207, 9.662],
   [53.547959, 9.849454],
   [53.55, 9.93333]]},
 {'id': '_New York->Santos_',
  'from': 'New York',
  'to': 'Santos',
  'distance': 5044.660367170626,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[40.7, -74.01],
   [40.701812, -74.024466],
   [40.661873, -74.046937],
   [40.637508, -74.05304],
   [40.53453, -74.009486],
   [37.085572, -69.138013],
   [15.589642, -57.78743],
   [-1.484514, -38.638729],
   [-5.269014, -34.595991],
   [-7.092683, -34.161525],
   [-9.100541, -34.463595],
   [-18.069687, -38.483549],
   [-22.317603, -40.932471],
   [-23.067394, -41.932178],
   [-24.008632, -45.2037],
   [-24.069078, -46.276052],
   [-24.039835, -46.331067],
   [-23.9946, -46.3299],
   [-23.980627, -46.337663]]},
 {'id': '_Santos->Rotterdam_',
  'from': 'Santos',
  'to': 'Rotterdam',
  'distance': 5439.734881209503,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[-23.980627, -46.337663],
   [-23.9946, -46.3299],
   [-24.039835, -46.331067],
   [-24.069078, -46.276052],
   [-24.008632, -45.2037],
   [-23.067394, -41.932178],
   [-22.317603, -40.932471],
   [-21.439968, -40.536904],
   [-17.854133, -38.088575],
   [-9.100541, -34.463595],
   [-3.044612, -32.794761],
   [19.922556, -24.551329],
   [33.216694, -17.447004],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_Santos->Antwerpen_',
  'from': 'Santos',
  'to': 'Antwerpen',
  'distance': 5430.903347732182,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[-23.980627, -46.337663],
   [-23.9946, -46.3299],
   [-24.039835, -46.331067],
   [-24.069078, -46.276052],
   [-24.008632, -45.2037],
   [-23.067394, -41.932178],
   [-22.317603, -40.932471],
   [-21.439968, -40.536904],
   [-17.854133, -38.088575],
   [-9.100541, -34.463595],
   [-3.044612, -32.794761],
   [19.922556, -24.551329],
   [33.216694, -17.447004],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.985054, 1.491261],
   [51.358673, 2.499172],
   [51.352547, 2.947911],
   [51.421738, 3.519379],
   [51.422429, 3.612437],
   [51.22472, 4.327261]]},
 {'id': '_Santos->Singapore_',
  'from': 'Santos',
  'to': 'Singapore',
  'distance': 8967.329373650107,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-23.980627, -46.337663],
   [-23.9946, -46.3299],
   [-24.039835, -46.331067],
   [-27.422222, -40.459612],
   [-35.124225, 19.591451],
   [-32.466852, 44.503775],
   [-5.961821, 105.775402],
   [-5.830915, 105.833383],
   [-5.442629, 105.97363],
   [-3.128016, 106.315256],
   [-2.834436, 105.912496],
   [-2.377311, 105.642791],
   [-2.279399, 105.319145],
   [-2.095235, 105.063824],
   [-1.06357, 104.51003],
   [-0.674341, 104.173798],
   [0.624711, 103.756654],
   [0.721348, 103.631241],
   [0.878661, 103.597977],
   [1.18334, 103.668675],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Santos->Shanghai_',
  'from': 'Santos',
  'to': 'Shanghai',
  'distance': 10989.88282937365,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-23.980627, -46.337663],
   [-23.9946, -46.3299],
   [-24.039835, -46.331067],
   [-27.422222, -40.459612],
   [-35.124225, 19.591451],
   [-32.466852, 44.503775],
   [-5.961821, 105.775402],
   [-3.254581, 106.985923],
   [-2.59377, 106.939174],
   [-0.732773, 107.621527],
   [2.107625, 108.290396],
   [3.127829, 108.642811],
   [22.835274, 117.229707],
   [25.251652, 120.204782],
   [30.389278, 122.912816],
   [30.929499, 122.870677],
   [31.296214, 121.77907],
   [31.405663, 121.544666]]},
 {'id': '_San Antonio->Shanghai_',
  'from': 'San Antonio',
  'to': 'Shanghai',
  'distance': 10226.89524838013,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-33.583731, -71.625913],
   [-33.611842, -71.691139],
   [-29.315545, -83.857578],
   [15.094778, -156.016662],
   [27.535784, 148.000194],
   [30.958577, 131.593448],
   [30.95217, 131.0209],
   [31.002833, 123.904357],
   [31.234738, 122.098721],
   [31.296214, 121.77907],
   [31.405663, 121.544666]]},
 {'id': '_San Antonio->Long Beach_',
  'from': 'San Antonio',
  'to': 'Long Beach',
  'distance': 4936.132289416847,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-33.583731, -71.625913],
   [-33.611842, -71.691139],
   [-19.847964, -82.553797],
   [-0.236236, -87.884353],
   [23.879051, -112.203761],
   [27.762408, -115.476182],
   [29.485787, -116.32845],
   [33.657073, -118.202901],
   [33.719161, -118.208295],
   [33.743188, -118.214062]]},
 {'id': '_San Antonio->Busan_',
  'from': 'San Antonio',
  'to': 'Busan',
  'distance': 10115.599352051835,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-33.583731, -71.625913],
   [-33.611842, -71.691139],
   [-19.847964, -82.553797],
   [-0.236236, -87.884353],
   [33.312777, -126.44551],
   [44.871556, 154.068314],
   [41.626027, 143.334973],
   [41.582751, 140.864849],
   [41.151196, 139.940285],
   [35.077889, 129.125237],
   [35.110908, 129.057511],
   [35.13, 129.05]]},
 {'id': '_San Antonio->Singapore_',
  'from': 'San Antonio',
  'to': 'Singapore',
  'distance': 9788.418466522679,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-33.583731, -71.625913],
   [-33.611842, -71.691139],
   [-33.790326, -72.25235],
   [-47.532691, -80.752659],
   [-48.091105, 167.390347],
   [-44.820133, 145.86887],
   [-35.540059, 116.435489],
   [-35.119758, 115.694917],
   [-34.535072, 114.671018],
   [-6.509312, 105.076411],
   [-5.961821, 105.775402],
   [-5.830915, 105.833383],
   [-5.442629, 105.97363],
   [-3.128016, 106.315256],
   [-2.834436, 105.912496],
   [-2.377311, 105.642791],
   [-2.279399, 105.319145],
   [-2.095235, 105.063824],
   [-1.06357, 104.51003],
   [-0.674341, 104.173798],
   [0.624711, 103.756654],
   [0.721348, 103.631241],
   [0.878661, 103.597977],
   [1.18334, 103.668675],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Durban->Singapore_',
  'from': 'Durban',
  'to': 'Singapore',
  'distance': 4881.967062634989,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-29.864237, 31.059373],
   [-29.8526, 31.0637],
   [-25.861671, 47.442961],
   [5.811947, 94.777273],
   [5.983644, 95.259146],
   [5.467016, 98.007266],
   [2.618388, 101.378225],
   [1.922056, 102.214665],
   [1.279813, 103.412156],
   [1.219293, 103.539816],
   [1.202515, 103.625522],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Durban->Rotterdam_',
  'from': 'Durban',
  'to': 'Rotterdam',
  'distance': 7028.643628509719,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[-29.864237, 31.059373],
   [-29.8526, 31.0637],
   [-29.856674, 31.231988],
   [-31.506009, 30.261849],
   [-32.388754, 29.507899],
   [-34.614678, 26.147049],
   [-34.980438, 19.847638],
   [-34.916269, 19.646144],
   [-34.660292, 18.843935],
   [-34.297753, 18.044058],
   [11.565631, -17.964712],
   [21.658419, -18.060608],
   [27.191026, -15.298828],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_Durban->Santos_',
  'from': 'Durban',
  'to': 'Santos',
  'distance': 4176.11555075594,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-29.864237, 31.059373],
   [-29.8526, 31.0637],
   [-29.856674, 31.231988],
   [-31.506009, 30.261849],
   [-32.388754, 29.507899],
   [-34.614678, 26.147049],
   [-35.124225, 19.591451],
   [-27.422222, -40.459612],
   [-24.039835, -46.331067],
   [-23.9946, -46.3299],
   [-23.980627, -46.337663]]},
 {'id': '_Durban->Jebel Ali_',
  'from': 'Durban',
  'to': 'Jebel Ali',
  'distance': 4053.563714902808,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-29.864237, 31.059373],
   [-29.8526, 31.0637],
   [-29.17657, 32.069473],
   [-25.881085, 35.631078],
   [-15.733314, 41.046358],
   [17.960183, 60.036389],
   [22.418407, 59.982448],
   [22.840891, 59.882404],
   [25.610655, 57.159535],
   [26.421797, 56.61533],
   [26.450409, 56.595042],
   [26.556975, 56.519435],
   [26.349851, 56.107086],
   [25.802904, 55.624014],
   [25.152555, 54.888019],
   [25.024675, 55.039722]]},
 {'id': '_Nhava Sheva->Jebel Ali_',
  'from': 'Nhava Sheva',
  'to': 'Jebel Ali',
  'distance': 1183.2883369330455,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[18.973669, 72.944412],
   [18.871719, 72.881542],
   [18.84336, 72.791641],
   [18.872286, 71.018779],
   [25.610655, 57.159535],
   [26.421797, 56.61533],
   [26.450409, 56.595042],
   [26.556975, 56.519435],
   [26.349851, 56.107086],
   [25.802904, 55.624014],
   [25.152555, 54.888019],
   [25.024675, 55.039722]]},
 {'id': '_Nhava Sheva->Singapore_',
  'from': 'Nhava Sheva',
  'to': 'Singapore',
  'distance': 2468.6495680345574,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[18.973669, 72.944412],
   [18.871719, 72.881542],
   [18.774144, 72.716123],
   [16.284872, 73.102101],
   [14.346178, 73.70512],
   [8.355051, 76.340902],
   [5.740204, 79.87949],
   [6.255202, 94.944615],
   [5.467016, 98.007266],
   [2.618388, 101.378225],
   [1.922056, 102.214665],
   [1.279813, 103.412156],
   [1.219293, 103.539816],
   [1.202515, 103.625522],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Nhava Sheva->Rotterdam_',
  'from': 'Nhava Sheva',
  'to': 'Rotterdam',
  'distance': 6385.54535637149,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[18.973669, 72.944412],
   [18.871719, 72.881542],
   [18.84336, 72.791641],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [37.44674, 11.11313],
   [37.687752, 8.778707],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.762514, -9.095293],
   [36.969759, -9.375811],
   [38.659776, -10.015606],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_Nhava Sheva->Hamburg_',
  'from': 'Nhava Sheva',
  'to': 'Hamburg',
  'distance': 6650.4184665226785,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[18.973669, 72.944412],
   [18.871719, 72.881542],
   [18.84336, 72.791641],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [37.44674, 11.11313],
   [37.687752, 8.778707],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.762514, -9.095293],
   [36.969759, -9.375811],
   [38.659776, -10.015606],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [52.451839, 3.598474],
   [53.374134, 4.774132],
   [53.435702, 4.857545],
   [53.754149, 6.338944],
   [53.983932, 8.241397],
   [53.944442, 8.628174],
   [53.871762, 8.760262],
   [53.844426, 8.852273],
   [53.875507, 9.108048],
   [53.863158, 9.286919],
   [53.816161, 9.358502],
   [53.752061, 9.413777],
   [53.710019, 9.49154],
   [53.624893, 9.54527],
   [53.571207, 9.662],
   [53.547959, 9.849454],
   [53.55, 9.93333]]},
 {'id': '_Sydney->Singapore_',
  'from': 'Sydney',
  'to': 'Singapore',
  'distance': 4148.272138228942,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-33.857159, 151.235733],
   [-34.03591, 151.403649],
   [-32.666212, 152.640697],
   [-31.520752, 153.15853],
   [-30.427247, 153.446216],
   [-28.927625, 153.801028],
   [-27.167367, 153.877744],
   [-24.487609, 153.609237],
   [-10.824612, 142.823432],
   [-10.638531, 142.598079],
   [-10.511272, 142.375123],
   [-10.487699, 142.23128],
   [-8.065375, 125.682777],
   [-5.702597, 120.493476],
   [-5.757573, 119.614413],
   [-3.28061, 110.253849],
   [1.272809, 104.585098],
   [1.221091, 103.950367],
   [1.135403, 103.735802],
   [1.18334, 103.668675],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Sydney->Shanghai_',
  'from': 'Sydney',
  'to': 'Shanghai',
  'distance': 4566.22192224622,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-33.857159, 151.235733],
   [-34.03591, 151.403649],
   [-32.666212, 152.640697],
   [-31.520752, 153.15853],
   [-30.427247, 153.446216],
   [-28.927625, 153.801028],
   [-27.167367, 153.877744],
   [-21.141324, 154.050528],
   [-8.338995, 151.160016],
   [-5.934205, 147.67183],
   [-1.049637, 145.170765],
   [16.834115, 132.613298],
   [30.929499, 122.870677],
   [31.296214, 121.77907],
   [31.405663, 121.544666]]},
 {'id': '_Sydney->Long Beach_',
  'from': 'Sydney',
  'to': 'Long Beach',
  'distance': 6528.25323974082,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-33.857159, 151.235733],
   [-34.03591, 151.403649],
   [-19.174644, 177.827553],
   [-17.419801, -179.9285],
   [30.575078, -124.981938],
   [33.544563, -118.549472],
   [33.657073, -118.202901],
   [33.719161, -118.208295],
   [33.743188, -118.214062]]},
 {'id': '_Valencia->Shanghai_',
  'from': 'Valencia',
  'to': 'Shanghai',
  'distance': 8936.987041036717,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[39.425785, -0.295],
   [39.411879, -0.274181],
   [39.17208, 2.071077],
   [37.246558, 11.58653],
   [31.582408, 31.91037],
   [31.277831, 32.356823],
   [31.219657, 32.34349],
   [31.124555, 32.316018],
   [31.098968, 32.309581],
   [31.01215, 32.311948],
   [30.92644, 32.315036],
   [30.882132, 32.316759],
   [30.856494, 32.31736],
   [30.806851, 32.319086],
   [30.72762, 32.340148],
   [30.716357, 32.343279],
   [30.702928, 32.343279],
   [30.615521, 32.32242],
   [30.584149, 32.307437],
   [30.573949, 32.305024],
   [30.567006, 32.305024],
   [30.549151, 32.310662],
   [30.516402, 32.33589],
   [30.450646, 32.351865],
   [30.409672, 32.364669],
   [30.311204, 32.403937],
   [30.270088, 32.474408],
   [30.261655, 32.49956],
   [30.255677, 32.515638],
   [30.220606, 32.55175],
   [30.185167, 32.568513],
   [30.062236, 32.571277],
   [29.981319, 32.585869],
   [29.968325, 32.586297],
   [29.95763, 32.58404],
   [29.942011, 32.574572],
   [29.925542, 32.558253],
   [29.919799, 32.556124],
   [29.594995, 32.575619],
   [28.515487, 33.045805],
   [27.987629, 33.505678],
   [27.391654, 34.218474],
   [13.552195, 42.612244],
   [13.200887, 43.024293],
   [12.756687, 43.27156],
   [12.624003, 43.384199],
   [12.551471, 43.528042],
   [12.425076, 43.911623],
   [12.116767, 44.974885],
   [14.380255, 53.237559],
   [5.539799, 81.030231],
   [6.255202, 94.944615],
   [5.467016, 98.007266],
   [2.618388, 101.378225],
   [1.922056, 102.214665],
   [1.279813, 103.412156],
   [1.219293, 103.539816],
   [1.135403, 103.735802],
   [1.318161, 104.317166],
   [1.508694, 104.543718],
   [22.835274, 117.229707],
   [25.251652, 120.204782],
   [30.389278, 122.912816],
   [30.929499, 122.870677],
   [31.296214, 121.77907],
   [31.405663, 121.544666]]},
 {'id': '_Valencia->Singapore_',
  'from': 'Valencia',
  'to': 'Singapore',
  'distance': 6740.430345572354,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[39.425785, -0.295],
   [39.411879, -0.274181],
   [39.17208, 2.071077],
   [37.246558, 11.58653],
   [31.582408, 31.91037],
   [31.277831, 32.356823],
   [31.219657, 32.34349],
   [31.124555, 32.316018],
   [31.098968, 32.309581],
   [31.01215, 32.311948],
   [30.92644, 32.315036],
   [30.882132, 32.316759],
   [30.856494, 32.31736],
   [30.806851, 32.319086],
   [30.72762, 32.340148],
   [30.716357, 32.343279],
   [30.702928, 32.343279],
   [30.615521, 32.32242],
   [30.584149, 32.307437],
   [30.573949, 32.305024],
   [30.567006, 32.305024],
   [30.549151, 32.310662],
   [30.516402, 32.33589],
   [30.450646, 32.351865],
   [30.409672, 32.364669],
   [30.311204, 32.403937],
   [30.270088, 32.474408],
   [30.261655, 32.49956],
   [30.255677, 32.515638],
   [30.220606, 32.55175],
   [30.185167, 32.568513],
   [30.062236, 32.571277],
   [29.981319, 32.585869],
   [29.968325, 32.586297],
   [29.95763, 32.58404],
   [29.942011, 32.574572],
   [29.925542, 32.558253],
   [29.919799, 32.556124],
   [29.594995, 32.575619],
   [28.515487, 33.045805],
   [27.987629, 33.505678],
   [27.391654, 34.218474],
   [13.552195, 42.612244],
   [13.200887, 43.024293],
   [12.756687, 43.27156],
   [12.624003, 43.384199],
   [12.551471, 43.528042],
   [12.425076, 43.911623],
   [12.116767, 44.974885],
   [14.380255, 53.237559],
   [5.539799, 81.030231],
   [6.255202, 94.944615],
   [5.467016, 98.007266],
   [2.618388, 101.378225],
   [1.922056, 102.214665],
   [1.279813, 103.412156],
   [1.219293, 103.539816],
   [1.202515, 103.625522],
   [1.272622, 103.748388],
   [1.278771, 103.756599]]},
 {'id': '_Valencia->Santos_',
  'from': 'Valencia',
  'to': 'Santos',
  'distance': 4780.194384449244,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[39.425785, -0.295],
   [39.411879, -0.274181],
   [39.378402, -0.221052],
   [38.822746, 0.284086],
   [38.729711, 0.365824],
   [37.54379, -0.513296],
   [36.457255, -2.216264],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [33.450779, -8.910639],
   [32.13611, -10.362751],
   [21.658419, -18.060608],
   [-3.738377, -30.193526],
   [-18.069687, -38.483549],
   [-22.317603, -40.932471],
   [-23.067394, -41.932178],
   [-24.008632, -45.2037],
   [-24.069078, -46.276052],
   [-24.039835, -46.331067],
   [-23.9946, -46.3299],
   [-23.980627, -46.337663]]},
 {'id': '_Valencia->New York_',
  'from': 'Valencia',
  'to': 'New York',
  'distance': 3606.9368250539956,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[39.425785, -0.295],
   [39.411879, -0.274181],
   [39.378402, -0.221052],
   [38.822746, 0.284086],
   [38.729711, 0.365824],
   [37.54379, -0.513296],
   [36.457255, -2.216264],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.465455, -9.987819],
   [40.828182, -29.765333],
   [40.327013, -61.542856],
   [40.45093, -73.768613],
   [40.53453, -74.009486],
   [40.637508, -74.05304],
   [40.661873, -74.046937],
   [40.701812, -74.024466],
   [40.7, -74.01]]},
 {'id': '_Shanghai->Valencia_',
  'from': 'Shanghai',
  'to': 'Valencia',
  'distance': 8934.363930885529,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[31.405663, 121.544666],
   [31.296214, 121.77907],
   [30.929499, 122.870677],
   [28.315245, 122.301208],
   [2.296991, 104.802635],
   [1.508694, 104.543718],
   [1.318161, 104.317166],
   [1.135403, 103.735802],
   [1.281086, 103.274421],
   [1.922056, 102.214665],
   [2.618388, 101.378225],
   [5.467016, 98.007266],
   [6.314776, 93.822642],
   [5.740204, 79.87949],
   [14.395023, 53.015171],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [39.17208, 2.071077],
   [39.411879, -0.274181],
   [39.425785, -0.295]]},
 {'id': '_Singapore->Valencia_',
  'from': 'Singapore',
  'to': 'Valencia',
  'distance': 6742.102051835853,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[1.278771, 103.756599],
   [1.272622, 103.748388],
   [1.202515, 103.625522],
   [1.219293, 103.539816],
   [1.281086, 103.274421],
   [1.922056, 102.214665],
   [2.618388, 101.378225],
   [5.467016, 98.007266],
   [6.314776, 93.822642],
   [5.740204, 79.87949],
   [14.395023, 53.015171],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [39.17208, 2.071077],
   [39.411879, -0.274181],
   [39.425785, -0.295]]},
 {'id': '_Santos->Valencia_',
  'from': 'Santos',
  'to': 'Valencia',
  'distance': 4780.79211663067,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[-23.980627, -46.337663],
   [-23.9946, -46.3299],
   [-24.039835, -46.331067],
   [-24.069078, -46.276052],
   [-24.008632, -45.2037],
   [-23.067394, -41.932178],
   [-22.317603, -40.932471],
   [-21.439968, -40.536904],
   [-17.854133, -38.088575],
   [-3.738377, -30.193526],
   [21.658419, -18.060608],
   [32.13611, -10.362751],
   [33.450779, -8.910639],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [36.457255, -2.216264],
   [37.54379, -0.513296],
   [38.729711, 0.365824],
   [38.822746, 0.284086],
   [39.378402, -0.221052],
   [39.411879, -0.274181],
   [39.425785, -0.295]]},
 {'id': '_New York->Valencia_',
  'from': 'New York',
  'to': 'Valencia',
  'distance': 3616.268898488121,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[40.7, -74.01],
   [40.701812, -74.024466],
   [40.661873, -74.046937],
   [40.637508, -74.05304],
   [40.53453, -74.009486],
   [40.056333, -73.047682],
   [40.327013, -61.542856],
   [40.828182, -29.765333],
   [36.465455, -9.987819],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [36.457255, -2.216264],
   [37.54379, -0.513296],
   [38.729711, 0.365824],
   [38.822746, 0.284086],
   [39.378402, -0.221052],
   [39.411879, -0.274181],
   [39.425785, -0.295]]},
 {'id': '_Nhava Sheva->Valencia_',
  'from': 'Nhava Sheva',
  'to': 'Valencia',
  'distance': 4730.296436285097,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[18.973669, 72.944412],
   [18.871719, 72.881542],
   [18.84336, 72.791641],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [39.17208, 2.071077],
   [39.411879, -0.274181],
   [39.425785, -0.295]]},
 {'id': '_Jebel Ali->Valencia_',
  'from': 'Jebel Ali',
  'to': 'Valencia',
  'distance': 4637.917926565875,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[25.024675, 55.039722],
   [25.152555, 54.888019],
   [25.293527, 55.077412],
   [26.392384, 56.137742],
   [26.556975, 56.519435],
   [26.450409, 56.595042],
   [26.40488, 56.688215],
   [25.610655, 57.159535],
   [22.637636, 59.900937],
   [22.418407, 59.982448],
   [20.558074, 59.493383],
   [19.835453, 58.857653],
   [18.311038, 57.498764],
   [14.31341, 52.751169],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [39.17208, 2.071077],
   [39.411879, -0.274181],
   [39.425785, -0.295]]},
 {'id': '_Rotterdam->Valencia_',
  'from': 'Rotterdam',
  'to': 'Valencia',
  'distance': 1802.6214902807776,
  'is_inter_europe': true,
  'is_mixed': false,
  'is_out': false,
  'coords': [[51.944424, 4.168453],
   [52.0223, 4.07924],
   [51.844907, 3.061935],
   [51.757716, 2.668369],
   [51.713796, 2.530332],
   [50.99019, 1.480863],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [43.249448, -9.976372],
   [38.659776, -10.015606],
   [36.939111, -9.296367],
   [36.549549, -8.948086],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [36.457255, -2.216264],
   [37.54379, -0.513296],
   [38.729711, 0.365824],
   [38.822746, 0.284086],
   [39.378402, -0.221052],
   [39.411879, -0.274181],
   [39.425785, -0.295]]},
 {'id': '_Antwerpen->Valencia_',
  'from': 'Antwerpen',
  'to': 'Valencia',
  'distance': 1793.39686825054,
  'is_inter_europe': true,
  'is_mixed': false,
  'is_out': false,
  'coords': [[51.22472, 4.327261],
   [51.422429, 3.612437],
   [51.421738, 3.519379],
   [51.351016, 2.786071],
   [51.358673, 2.499172],
   [50.985054, 1.491261],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [43.249448, -9.976372],
   [38.659776, -10.015606],
   [36.939111, -9.296367],
   [36.549549, -8.948086],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [36.457255, -2.216264],
   [37.54379, -0.513296],
   [38.729711, 0.365824],
   [38.822746, 0.284086],
   [39.378402, -0.221052],
   [39.411879, -0.274181],
   [39.425785, -0.295]]},
 {'id': '_Hamburg->Valencia_',
  'from': 'Hamburg',
  'to': 'Valencia',
  'distance': 2067.55777537797,
  'is_inter_europe': true,
  'is_mixed': false,
  'is_out': false,
  'coords': [[53.55, 9.93333],
   [53.547959, 9.849454],
   [53.571207, 9.662],
   [53.624893, 9.54527],
   [53.710019, 9.49154],
   [53.752061, 9.413777],
   [53.816161, 9.358502],
   [53.863158, 9.286919],
   [53.875507, 9.108048],
   [53.844426, 8.852273],
   [53.871762, 8.760262],
   [53.944442, 8.628174],
   [53.993596, 8.187102],
   [53.754149, 6.338944],
   [53.435702, 4.857545],
   [53.317264, 4.641315],
   [52.451839, 3.598474],
   [50.99019, 1.480863],
   [50.545315, 0.724702],
   [49.873662, -3.071187],
   [48.864544, -5.660632],
   [47.84289, -6.479628],
   [43.249448, -9.976372],
   [38.659776, -10.015606],
   [36.939111, -9.296367],
   [36.549549, -8.948086],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [36.457255, -2.216264],
   [37.54379, -0.513296],
   [38.729711, 0.365824],
   [38.822746, 0.284086],
   [39.378402, -0.221052],
   [39.411879, -0.274181],
   [39.425785, -0.295]]},
 {'id': '_Rotterdam->Antwerpen_',
  'from': 'Rotterdam',
  'to': 'Antwerpen',
  'distance': 89.4757019438445,
  'is_inter_europe': true,
  'is_mixed': false,
  'is_out': false,
  'coords': [[51.944424, 4.168453],
   [52.0223, 4.07924],
   [51.999435, 3.956622],
   [51.982823, 3.926107],
   [51.9535, 3.87791],
   [51.897898, 3.880945],
   [51.5959, 3.33705],
   [51.51942, 3.414122],
   [51.449435, 3.506178],
   [51.429658, 3.565336],
   [51.422429, 3.612437],
   [51.22472, 4.327261]]},
 {'id': '_Rotterdam->Hamburg_',
  'from': 'Rotterdam',
  'to': 'Hamburg',
  'distance': 291.5988120950324,
  'is_inter_europe': true,
  'is_mixed': false,
  'is_out': false,
  'coords': [[51.944424, 4.168453],
   [52.0223, 4.07924],
   [52.083249, 4.106132],
   [52.821449, 4.567131],
   [52.967651, 4.7154],
   [52.994628, 4.798007],
   [53.108954, 5.086982],
   [53.253946, 5.157276],
   [53.31454, 5.155641],
   [53.375547, 5.106622],
   [53.527797, 5.284821],
   [53.754149, 6.338944],
   [53.983932, 8.241397],
   [53.944442, 8.628174],
   [53.871762, 8.760262],
   [53.844426, 8.852273],
   [53.875507, 9.108048],
   [53.863158, 9.286919],
   [53.816161, 9.358502],
   [53.752061, 9.413777],
   [53.710019, 9.49154],
   [53.624893, 9.54527],
   [53.571207, 9.662],
   [53.547959, 9.849454],
   [53.55, 9.93333]]},
 {'id': '_Antwerpen->Hamburg_',
  'from': 'Antwerpen',
  'to': 'Hamburg',
  'distance': 369.3704103671706,
  'is_inter_europe': true,
  'is_mixed': false,
  'is_out': false,
  'coords': [[51.22472, 4.327261],
   [51.422429, 3.612437],
   [51.429658, 3.565336],
   [51.449435, 3.506178],
   [51.51942, 3.414122],
   [51.5959, 3.33705],
   [51.744813, 3.292435],
   [52.161037, 3.36232],
   [53.374134, 4.774132],
   [53.435702, 4.857545],
   [53.754149, 6.338944],
   [53.983932, 8.241397],
   [53.944442, 8.628174],
   [53.871762, 8.760262],
   [53.844426, 8.852273],
   [53.875507, 9.108048],
   [53.863158, 9.286919],
   [53.816161, 9.358502],
   [53.752061, 9.413777],
   [53.710019, 9.49154],
   [53.624893, 9.54527],
   [53.571207, 9.662],
   [53.547959, 9.849454],
   [53.55, 9.93333]]},
 {'id': '_Antwerpen->Rotterdam_',
  'from': 'Antwerpen',
  'to': 'Rotterdam',
  'distance': 369.3704103671706,
  'is_inter_europe': true,
  'is_mixed': false,
  'is_out': false,
  'coords': [[51.22472, 4.327261],
   [51.422429, 3.612437],
   [51.429658, 3.565336],
   [51.449435, 3.506178],
   [51.51942, 3.414122],
   [51.5959, 3.33705],
   [51.744813, 3.292435],
   [52.161037, 3.36232],
   [53.374134, 4.774132],
   [53.435702, 4.857545],
   [53.754149, 6.338944],
   [53.983932, 8.241397],
   [53.944442, 8.628174],
   [53.871762, 8.760262],
   [53.844426, 8.852273],
   [53.875507, 9.108048],
   [53.863158, 9.286919],
   [53.816161, 9.358502],
   [53.752061, 9.413777],
   [53.710019, 9.49154],
   [53.624893, 9.54527],
   [53.571207, 9.662],
   [53.547959, 9.849454],
   [53.55, 9.93333]]},
 {'id': '_Valencia->Hamburg_',
  'from': 'Valencia',
  'to': 'Hamburg',
  'distance': 2064.5172786177104,
  'is_inter_europe': true,
  'is_mixed': false,
  'is_out': false,
  'coords': [[39.425785, -0.295],
   [39.411879, -0.274181],
   [39.378402, -0.221052],
   [38.822746, 0.284086],
   [38.729711, 0.365824],
   [37.54379, -0.513296],
   [36.457255, -2.216264],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.762514, -9.095293],
   [36.969759, -9.375811],
   [38.659776, -10.015606],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [52.451839, 3.598474],
   [53.374134, 4.774132],
   [53.435702, 4.857545],
   [53.754149, 6.338944],
   [53.983932, 8.241397],
   [53.944442, 8.628174],
   [53.871762, 8.760262],
   [53.844426, 8.852273],
   [53.875507, 9.108048],
   [53.863158, 9.286919],
   [53.816161, 9.358502],
   [53.752061, 9.413777],
   [53.710019, 9.49154],
   [53.624893, 9.54527],
   [53.571207, 9.662],
   [53.547959, 9.849454],
   [53.55, 9.93333]]},
   {'id': '_Cartagena->Algeciras_',
  'from': 'Cartagena',
  'to': 'Algeciras',
  'distance': 4114.67980561555,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[10.358489, -75.572033],
   [10.419218, -75.590414],
   [10.512413, -75.63677],
   [10.836642, -75.491129],
   [11.125238, -74.869909],
   [12.206395, -73.339637],
   [16.956265, -61.034938],
   [17.557621, -60.013013],
   [33.177575, -23.294209],
   [35.346544, -9.583364],
   [35.939154, -5.704624],
   [36.018348, -5.431818],
   [36.0967, -5.38227],
   [36.139887, -5.420595]]},
 {'id': '_Cartagena->Casablanca_',
  'from': 'Cartagena',
  'to': 'Casablanca',
  'distance': 3991.820734341253,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[10.358489, -75.572033],
   [10.419218, -75.590414],
   [10.512413, -75.63677],
   [10.836642, -75.491129],
   [11.125238, -74.869909],
   [12.206395, -73.339637],
   [16.956265, -61.034938],
   [17.557621, -60.013013],
   [33.968142, -9.092727],
   [33.6264, -7.57925],
   [33.616989, -7.590487]]},
 {'id': '_Cartagena->Las Palmas_',
  'from': 'Cartagena',
  'to': 'Las Palmas',
  'distance': 3571.496760259179,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[10.358489, -75.572033],
   [10.419218, -75.590414],
   [10.512413, -75.63677],
   [10.836642, -75.491129],
   [11.125238, -74.869909],
   [12.206395, -73.339637],
   [17.391039, -59.823728],
   [28.348708, -17.334626],
   [28.596026, -16.329555],
   [28.604958, -16.113141],
   [28.179608, -15.3798],
   [28.1198, -15.3911],
   [28.126724, -15.413197]]},
 {'id': '_Las Palmas->Casablanca_',
  'from': 'Las Palmas',
  'to': 'Casablanca',
  'distance': 534.883909287257,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[28.126724, -15.413197],
   [28.1198, -15.3911],
   [33.450779, -8.910639],
   [33.588336, -8.576479],
   [33.718715, -8.034671],
   [33.6264, -7.57925],
   [33.616989, -7.590487]]},
 {'id': '_Las Palmas->Rotterdam_',
  'from': 'Las Palmas',
  'to': 'Rotterdam',
  'distance': 1761.5836933045357,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[28.126724, -15.413197],
   [28.1198, -15.3911],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_Las Palmas->Algeciras_',
  'from': 'Las Palmas',
  'to': 'Algeciras',
  'distance': 707.4989200863931,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[28.126724, -15.413197],
   [28.1198, -15.3911],
   [33.77409, -9.024301],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [36.018348, -5.431818],
   [36.0967, -5.38227],
   [36.139887, -5.420595]]},
 {'id': '_Algeciras->Rotterdam_',
  'from': 'Algeciras',
  'to': 'Rotterdam',
  'distance': 1411.3650107991361,
  'is_inter_europe': true,
  'is_mixed': false,
  'is_out': false,
  'coords': [[36.139887, -5.420595],
   [36.0967, -5.38227],
   [36.018348, -5.431818],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.762514, -9.095293],
   [36.969759, -9.375811],
   [38.659776, -10.015606],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_Casablanca->Rotterdam_',
  'from': 'Casablanca',
  'to': 'Rotterdam',
  'distance': 1411.3650107991361,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[36.139887, -5.420595],
   [36.0967, -5.38227],
   [36.018348, -5.431818],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.762514, -9.095293],
   [36.969759, -9.375811],
   [38.659776, -10.015606],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_Porto Du Acu->Rotterdam_',
  'from': 'Porto Du Acu',
  'to': 'Rotterdam',
  'distance': 5096.084773218143,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[-21.844461, -40.973197],
   [-21.86778, -40.820993],
   [-21.439968, -40.536904],
   [-17.854133, -38.088575],
   [-9.100541, -34.463595],
   [-3.044612, -32.794761],
   [17.344551, -25.847417],
   [19.922556, -24.551329],
   [33.216694, -17.447004],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_Porto Du Acu->Casablanca_',
  'from': 'Porto Du Acu',
  'to': 'Casablanca',
  'distance': 3874.7316414686825,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-21.844461, -40.973197],
   [-21.86778, -40.820993],
   [-21.439968, -40.536904],
   [-17.854133, -38.088575],
   [-3.738377, -30.193526],
   [21.658419, -18.060608],
   [32.13611, -10.362751],
   [33.450779, -8.910639],
   [33.588336, -8.576479],
   [33.718715, -8.034671],
   [33.6264, -7.57925],
   [33.616989, -7.590487]]},
 {'id': '_Porto Du Acu->Algeciras_',
  'from': 'Porto Du Acu',
  'to': 'Algeciras',
  'distance': 4048.017818574514,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[-21.844461, -40.973197],
   [-21.86778, -40.820993],
   [-21.439968, -40.536904],
   [-17.854133, -38.088575],
   [-3.738377, -30.193526],
   [21.658419, -18.060608],
   [32.13611, -10.362751],
   [33.450779, -8.910639],
   [35.877653, -6.170674],
   [35.939154, -5.704624],
   [36.018348, -5.431818],
   [36.0967, -5.38227],
   [36.139887, -5.420595]]},
 {'id': '_Callao->Porto Du Acu_',
  'from': 'Callao',
  'to': 'Porto Du Acu',
  'distance': 5020.024838012959,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-12.049321, -77.159005],
   [-12.004305, -77.172874],
   [-11.979793, -77.35517],
   [-46.825545, -75.90494],
   [-50.260424, -75.714243],
   [-52.059404, -75.438379],
   [-52.544788, -74.662297],
   [-53.091315, -73.405127],
   [-53.314964, -73.086552],
   [-53.550677, -72.476807],
   [-53.557799, -72.365478],
   [-53.771095, -71.955123],
   [-53.804306, -71.891041],
   [-53.931557, -71.306451],
   [-53.810374, -70.943344],
   [-52.778524, -70.537419],
   [-52.644668, -69.814631],
   [-52.395661, -69.248199],
   [-52.483107, -68.387503],
   [-52.227014, -67.506852],
   [-22.317603, -40.932471],
   [-21.86778, -40.820993],
   [-21.844461, -40.973197]]},
 {'id': '_Callao->Cartagena_',
  'from': 'Callao',
  'to': 'Cartagena',
  'distance': 1681.0124190064794,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-12.049321, -77.159005],
   [-12.004305, -77.172874],
   [-11.469244, -77.851427],
   [-5.968353, -81.713649],
   [-1.213762, -81.373269],
   [7.72801, -79.394075],
   [8.761358, -79.44047],
   [8.924378, -79.548307],
   [8.93049, -79.5521],
   [8.945524, -79.567771],
   [8.958615, -79.571032],
   [8.990627, -79.585967],
   [9.00065, -79.596123],
   [9.016395, -79.612386],
   [9.02188, -79.619039],
   [9.026165, -79.626555],
   [9.036118, -79.639835],
   [9.036662, -79.640561],
   [9.04102, -79.64537],
   [9.057248, -79.657177],
   [9.067839, -79.670776],
   [9.085343, -79.679082],
   [9.106707, -79.69162],
   [9.111162, -79.699224],
   [9.114387, -79.706631],
   [9.120886, -79.747636],
   [9.120047, -79.756717],
   [9.114721, -79.764943],
   [9.114721, -79.774246],
   [9.11962, -79.802032],
   [9.166948, -79.820004],
   [9.180535, -79.841254],
   [9.184209, -79.845106],
   [9.183468, -79.857655],
   [9.183828, -79.874003],
   [9.213915, -79.927405],
   [9.247629, -79.923366],
   [9.26561, -79.924333],
   [9.280338, -79.922221],
   [9.31344, -79.919081],
   [9.354863, -79.921237],
   [9.395463, -79.916409],
   [9.733797, -79.652535],
   [10.419218, -75.590414],
   [10.358489, -75.572033]]},
 {'id': '_Tuticorin->Valencia_',
  'from': 'Tuticorin',
  'to': 'Valencia',
  'distance': 5134.035097192224,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[8.751147, 78.218279],
   [8.554864, 78.424281],
   [7.795504, 77.580404],
   [14.395023, 53.015171],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [39.17208, 2.071077],
   [39.411879, -0.274181],
   [39.425785, -0.295]]},
   {'id': '_Tuticorin->Algeciras_',
  'from': 'Tuticorin',
  'to': 'Algeciras',
  'distance': 5386.575593952483,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[8.751147, 78.218279],
   [8.554864, 78.424281],
   [7.795504, 77.580404],
   [14.395023, 53.015171],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [37.44674, 11.11313],
   [37.687752, 8.778707],
   [36.087735, -5.292047],
   [36.0967, -5.38227],
   [36.139887, -5.420595]]},
 {'id': '_Singapore->Tuticorin_',
  'from': 'Singapore',
  'to': 'Tuticorin',
  'distance': 1719.7813174946004,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[1.278771, 103.756599],
   [1.272622, 103.748388],
   [1.202515, 103.625522],
   [1.219293, 103.539816],
   [1.281086, 103.274421],
   [1.922056, 102.214665],
   [2.618388, 101.378225],
   [5.467016, 98.007266],
   [6.314776, 93.822642],
   [5.632823, 80.496131],
   [5.877048, 80.173169],
   [6.098787, 79.98018],
   [8.554864, 78.424281],
   [8.751147, 78.218279]]},
 {'id': '_Valencia->Algeciras_',
  'from': 'Valencia',
  'to': 'Algeciras',
  'distance': 397.1128509719222,
  'is_inter_europe': true,
  'is_mixed': false,
  'is_out': false,
  'coords': [[39.425785, -0.295],
   [39.411879, -0.274181],
   [39.378402, -0.221052],
   [38.822746, 0.284086],
   [38.729711, 0.365824],
   [37.54379, -0.513296],
   [36.457255, -2.216264],
   [36.087735, -5.292047],
   [36.0967, -5.38227],
   [36.139887, -5.420595]]},
   {'id': '_Balboa->New York_',
  'from': 'Balboa',
  'to': 'New York',
  'distance': 2017.5329373650109,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[8.956954, -79.562924],
   [8.955342, -79.570217],
   [8.981897, -79.580968],
   [8.990627, -79.585967],
   [9.00065, -79.596123],
   [9.016395, -79.612386],
   [9.02188, -79.619039],
   [9.026165, -79.626555],
   [9.036118, -79.639835],
   [9.036662, -79.640561],
   [9.04102, -79.64537],
   [9.057248, -79.657177],
   [9.067839, -79.670776],
   [9.085343, -79.679082],
   [9.106707, -79.69162],
   [9.111162, -79.699224],
   [9.114387, -79.706631],
   [9.120886, -79.747636],
   [9.120047, -79.756717],
   [9.114721, -79.764943],
   [9.114721, -79.774246],
   [9.11962, -79.802032],
   [9.166948, -79.820004],
   [9.180535, -79.841254],
   [9.184209, -79.845106],
   [9.183468, -79.857655],
   [9.183828, -79.874003],
   [9.213915, -79.927405],
   [9.247629, -79.923366],
   [9.26561, -79.924333],
   [9.280338, -79.922221],
   [9.31344, -79.919081],
   [9.354863, -79.921237],
   [9.395463, -79.916409],
   [20.038708, -74.014044],
   [20.413638, -73.991478],
   [20.532012, -74.014944],
   [22.508168, -73.290336],
   [24.207149, -73.002179],
   [35.086128, -73.661077],
   [40.424245, -73.912456],
   [40.53453, -74.009486],
   [40.637508, -74.05304],
   [40.661873, -74.046937],
   [40.701812, -74.024466],
   [40.7, -74.01]]},
 {'id': '_Balboa->Porto Du Acu_',
  'from': 'Balboa',
  'to': 'Porto Du Acu',
  'distance': 4179.992980561555,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[8.956954, -79.562924],
   [8.955342, -79.570217],
   [8.981897, -79.580968],
   [8.990627, -79.585967],
   [9.00065, -79.596123],
   [9.016395, -79.612386],
   [9.02188, -79.619039],
   [9.026165, -79.626555],
   [9.036118, -79.639835],
   [9.036662, -79.640561],
   [9.04102, -79.64537],
   [9.057248, -79.657177],
   [9.067839, -79.670776],
   [9.085343, -79.679082],
   [9.106707, -79.69162],
   [9.111162, -79.699224],
   [9.114387, -79.706631],
   [9.120886, -79.747636],
   [9.120047, -79.756717],
   [9.114721, -79.764943],
   [9.114721, -79.774246],
   [9.11962, -79.802032],
   [9.166948, -79.820004],
   [9.180535, -79.841254],
   [9.184209, -79.845106],
   [9.183468, -79.857655],
   [9.183828, -79.874003],
   [9.213915, -79.927405],
   [9.247629, -79.923366],
   [9.26561, -79.924333],
   [9.280338, -79.922221],
   [9.31344, -79.919081],
   [9.354863, -79.921237],
   [9.395463, -79.916409],
   [9.733797, -79.652535],
   [13.751119, -69.366493],
   [11.60207, -61.8009],
   [11.520679, -60.264694],
   [-4.874964, -35.239896],
   [-5.118567, -35.002556],
   [-6.949473, -34.491914],
   [-9.4426, -34.603017],
   [-18.069687, -38.483549],
   [-21.439968, -40.536904],
   [-21.86778, -40.820993],
   [-21.844461, -40.973197]]},
 {'id': '_Balboa->Cartagena_',
  'from': 'Balboa',
  'to': 'Cartagena',
  'distance': 313.3304535637149,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[8.956954, -79.562924],
   [8.955342, -79.570217],
   [8.981897, -79.580968],
   [8.990627, -79.585967],
   [9.00065, -79.596123],
   [9.016395, -79.612386],
   [9.02188, -79.619039],
   [9.026165, -79.626555],
   [9.036118, -79.639835],
   [9.036662, -79.640561],
   [9.04102, -79.64537],
   [9.057248, -79.657177],
   [9.067839, -79.670776],
   [9.085343, -79.679082],
   [9.106707, -79.69162],
   [9.111162, -79.699224],
   [9.114387, -79.706631],
   [9.120886, -79.747636],
   [9.120047, -79.756717],
   [9.114721, -79.764943],
   [9.114721, -79.774246],
   [9.11962, -79.802032],
   [9.166948, -79.820004],
   [9.180535, -79.841254],
   [9.184209, -79.845106],
   [9.183468, -79.857655],
   [9.183828, -79.874003],
   [9.213915, -79.927405],
   [9.247629, -79.923366],
   [9.26561, -79.924333],
   [9.280338, -79.922221],
   [9.31344, -79.919081],
   [9.354863, -79.921237],
   [9.395463, -79.916409],
   [9.733797, -79.652535],
   [10.419218, -75.590414],
   [10.358489, -75.572033]]},
 {'id': '_Balboa->Santos_',
  'from': 'Balboa',
  'to': 'Santos',
  'distance': 4524.088552915767,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[8.956954, -79.562924],
   [8.955342, -79.570217],
   [8.981897, -79.580968],
   [8.990627, -79.585967],
   [9.00065, -79.596123],
   [9.016395, -79.612386],
   [9.02188, -79.619039],
   [9.026165, -79.626555],
   [9.036118, -79.639835],
   [9.036662, -79.640561],
   [9.04102, -79.64537],
   [9.057248, -79.657177],
   [9.067839, -79.670776],
   [9.085343, -79.679082],
   [9.106707, -79.69162],
   [9.111162, -79.699224],
   [9.114387, -79.706631],
   [9.120886, -79.747636],
   [9.120047, -79.756717],
   [9.114721, -79.764943],
   [9.114721, -79.774246],
   [9.11962, -79.802032],
   [9.166948, -79.820004],
   [9.180535, -79.841254],
   [9.184209, -79.845106],
   [9.183468, -79.857655],
   [9.183828, -79.874003],
   [9.213915, -79.927405],
   [9.247629, -79.923366],
   [9.26561, -79.924333],
   [9.280338, -79.922221],
   [9.31344, -79.919081],
   [9.354863, -79.921237],
   [9.395463, -79.916409],
   [9.733797, -79.652535],
   [13.751119, -69.366493],
   [11.60207, -61.8009],
   [11.520679, -60.264694],
   [-4.874964, -35.239896],
   [-5.118567, -35.002556],
   [-6.949473, -34.491914],
   [-9.4426, -34.603017],
   [-18.069687, -38.483549],
   [-22.317603, -40.932471],
   [-23.067394, -41.932178],
   [-24.008632, -45.2037],
   [-24.069078, -46.276052],
   [-24.039835, -46.331067],
   [-23.9946, -46.3299],
   [-23.980627, -46.337663]]},
 {'id': '_Balboa->Las Palmas_',
  'from': 'Balboa',
  'to': 'Las Palmas',
  'distance': 3855.0199784017277,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[8.956954, -79.562924],
   [8.955342, -79.570217],
   [8.981897, -79.580968],
   [8.990627, -79.585967],
   [9.00065, -79.596123],
   [9.016395, -79.612386],
   [9.02188, -79.619039],
   [9.026165, -79.626555],
   [9.036118, -79.639835],
   [9.036662, -79.640561],
   [9.04102, -79.64537],
   [9.057248, -79.657177],
   [9.067839, -79.670776],
   [9.085343, -79.679082],
   [9.106707, -79.69162],
   [9.111162, -79.699224],
   [9.114387, -79.706631],
   [9.120886, -79.747636],
   [9.120047, -79.756717],
   [9.114721, -79.764943],
   [9.114721, -79.774246],
   [9.11962, -79.802032],
   [9.166948, -79.820004],
   [9.180535, -79.841254],
   [9.184209, -79.845106],
   [9.183468, -79.857655],
   [9.183828, -79.874003],
   [9.213915, -79.927405],
   [9.247629, -79.923366],
   [9.26561, -79.924333],
   [9.280338, -79.922221],
   [9.31344, -79.919081],
   [9.354863, -79.921237],
   [9.395463, -79.916409],
   [9.733797, -79.652535],
   [17.391039, -59.823728],
   [28.348708, -17.334626],
   [28.596026, -16.329555],
   [28.604958, -16.113141],
   [28.179608, -15.3798],
   [28.1198, -15.3911],
   [28.126724, -15.413197]]},
 {'id': '_Balboa->Casablanca_',
  'from': 'Balboa',
  'to': 'Casablanca',
  'distance': 4275.359611231102,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[8.956954, -79.562924],
   [8.955342, -79.570217],
   [8.981897, -79.580968],
   [8.990627, -79.585967],
   [9.00065, -79.596123],
   [9.016395, -79.612386],
   [9.02188, -79.619039],
   [9.026165, -79.626555],
   [9.036118, -79.639835],
   [9.036662, -79.640561],
   [9.04102, -79.64537],
   [9.057248, -79.657177],
   [9.067839, -79.670776],
   [9.085343, -79.679082],
   [9.106707, -79.69162],
   [9.111162, -79.699224],
   [9.114387, -79.706631],
   [9.120886, -79.747636],
   [9.120047, -79.756717],
   [9.114721, -79.764943],
   [9.114721, -79.774246],
   [9.11962, -79.802032],
   [9.166948, -79.820004],
   [9.180535, -79.841254],
   [9.184209, -79.845106],
   [9.183468, -79.857655],
   [9.183828, -79.874003],
   [9.213915, -79.927405],
   [9.247629, -79.923366],
   [9.26561, -79.924333],
   [9.280338, -79.922221],
   [9.31344, -79.919081],
   [9.354863, -79.921237],
   [9.395463, -79.916409],
   [9.733797, -79.652535],
   [16.956265, -61.034938],
   [17.557621, -60.013013],
   [33.968142, -9.092727],
   [33.6264, -7.57925],
   [33.616989, -7.590487]]},
 {'id': '_Balboa->Algeciras_',
  'from': 'Balboa',
  'to': 'Algeciras',
  'distance': 4378.002159827214,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': true,
  'coords': [[8.956954, -79.562924],
   [8.955342, -79.570217],
   [8.981897, -79.580968],
   [8.990627, -79.585967],
   [9.00065, -79.596123],
   [9.016395, -79.612386],
   [9.02188, -79.619039],
   [9.026165, -79.626555],
   [9.036118, -79.639835],
   [9.036662, -79.640561],
   [9.04102, -79.64537],
   [9.057248, -79.657177],
   [9.067839, -79.670776],
   [9.085343, -79.679082],
   [9.106707, -79.69162],
   [9.111162, -79.699224],
   [9.114387, -79.706631],
   [9.120886, -79.747636],
   [9.120047, -79.756717],
   [9.114721, -79.764943],
   [9.114721, -79.774246],
   [9.11962, -79.802032],
   [9.166948, -79.820004],
   [9.180535, -79.841254],
   [9.184209, -79.845106],
   [9.183468, -79.857655],
   [9.183828, -79.874003],
   [9.213915, -79.927405],
   [9.247629, -79.923366],
   [9.26561, -79.924333],
   [9.280338, -79.922221],
   [9.31344, -79.919081],
   [9.354863, -79.921237],
   [9.395463, -79.916409],
   [9.865426, -79.57089],
   [17.954517, -68.259437],
   [20.515848, -65.178971],
   [35.721952, -9.718428],
   [35.939154, -5.704624],
   [36.018348, -5.431818],
   [36.0967, -5.38227],
   [36.139887, -5.420595]]},
 {'id': '_Balboa->Rotterdam_',
  'from': 'Balboa',
  'to': 'Rotterdam',
  'distance': 4837.394168466522,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[8.956954, -79.562924],
   [8.955342, -79.570217],
   [8.981897, -79.580968],
   [8.990627, -79.585967],
   [9.00065, -79.596123],
   [9.016395, -79.612386],
   [9.02188, -79.619039],
   [9.026165, -79.626555],
   [9.036118, -79.639835],
   [9.036662, -79.640561],
   [9.04102, -79.64537],
   [9.057248, -79.657177],
   [9.067839, -79.670776],
   [9.085343, -79.679082],
   [9.106707, -79.69162],
   [9.111162, -79.699224],
   [9.114387, -79.706631],
   [9.120886, -79.747636],
   [9.120047, -79.756717],
   [9.114721, -79.764943],
   [9.114721, -79.774246],
   [9.11962, -79.802032],
   [9.166948, -79.820004],
   [9.180535, -79.841254],
   [9.184209, -79.845106],
   [9.183468, -79.857655],
   [9.183828, -79.874003],
   [9.213915, -79.927405],
   [9.247629, -79.923366],
   [9.26561, -79.924333],
   [9.280338, -79.922221],
   [9.31344, -79.919081],
   [9.354863, -79.921237],
   [9.395463, -79.916409],
   [9.865426, -79.57089],
   [17.954517, -68.259437],
   [20.825058, -65.826569],
   [49.402603, -7.285783],
   [50.606854, 0.828873],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_Long Beach->Balboa_',
  'from': 'Long Beach',
  'to': 'Balboa',
  'distance': 2951.929265658747,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[33.743188, -118.214062],
   [33.719161, -118.208295],
   [33.544753, -118.131878],
   [29.485787, -116.32845],
   [27.762408, -115.476182],
   [23.879051, -112.203761],
   [17.990253, -104.085388],
   [6.990782, -81.894306],
   [6.976505, -80.225731],
   [7.721903, -79.44898],
   [8.761358, -79.44047],
   [8.924378, -79.548307],
   [8.93049, -79.5521],
   [8.945524, -79.567771],
   [8.955342, -79.570217],
   [8.956954, -79.562924]]},
 {'id': '_Callao->Balboa_',
  'from': 'Callao',
  'to': 'Balboa',
  'distance': 1368.5691144708424,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-12.049321, -77.159005],
   [-12.004305, -77.172874],
   [-11.469244, -77.851427],
   [-5.968353, -81.713649],
   [-1.213762, -81.373269],
   [7.72801, -79.394075],
   [8.761358, -79.44047],
   [8.924378, -79.548307],
   [8.93049, -79.5521],
   [8.945524, -79.567771],
   [8.955342, -79.570217],
   [8.956954, -79.562924]]},
 {'id': '_San Antonio->Balboa_',
  'from': 'San Antonio',
  'to': 'Balboa',
  'distance': 2667.804535637149,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-33.583731, -71.625913],
   [-33.611842, -71.691139],
   [-33.064038, -72.058162],
   [-5.968353, -81.713649],
   [-1.213762, -81.373269],
   [7.72801, -79.394075],
   [8.761358, -79.44047],
   [8.924378, -79.548307],
   [8.93049, -79.5521],
   [8.945524, -79.567771],
   [8.955342, -79.570217],
   [8.956954, -79.562924]]},
   {'id': '_Colombo->Valencia_',
  'from': 'Colombo',
  'to': 'Valencia',
  'distance': 5192.808315334773,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[6.967749, 79.843912],
   [7.002643, 79.763217],
   [14.395023, 53.015171],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [39.17208, 2.071077],
   [39.411879, -0.274181],
   [39.425785, -0.295]]},
 {'id': '_Colombo->Rotterdam_',
  'from': 'Colombo',
  'to': 'Rotterdam',
  'distance': 6848.057235421166,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[6.967749, 79.843912],
   [7.002643, 79.763217],
   [14.395023, 53.015171],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [37.44674, 11.11313],
   [37.687752, 8.778707],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.762514, -9.095293],
   [36.969759, -9.375811],
   [38.659776, -10.015606],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [51.730387, 2.625457],
   [51.757716, 2.668369],
   [51.844907, 3.061935],
   [51.90168, 3.395424],
   [52.0223, 4.07924],
   [51.944424, 4.168453]]},
 {'id': '_Colombo->Hamburg_',
  'from': 'Colombo',
  'to': 'Hamburg',
  'distance': 7112.930345572354,
  'is_inter_europe': false,
  'is_mixed': true,
  'is_out': false,
  'coords': [[6.967749, 79.843912],
   [7.002643, 79.763217],
   [14.395023, 53.015171],
   [12.116767, 44.974885],
   [12.425076, 43.911623],
   [12.551471, 43.528042],
   [12.624003, 43.384199],
   [12.756687, 43.27156],
   [13.281884, 42.984104],
   [13.552195, 42.612244],
   [27.470856, 34.080598],
   [28.211973, 33.336787],
   [28.800636, 32.853966],
   [29.081667, 32.759318],
   [29.594995, 32.575619],
   [29.919799, 32.556124],
   [29.925542, 32.558253],
   [29.942011, 32.574572],
   [29.95763, 32.58404],
   [29.968325, 32.586297],
   [29.981319, 32.585869],
   [30.062236, 32.571277],
   [30.185167, 32.568513],
   [30.220606, 32.55175],
   [30.255677, 32.515638],
   [30.275428, 32.467415],
   [30.311204, 32.403937],
   [30.409672, 32.364669],
   [30.450646, 32.351865],
   [30.516402, 32.33589],
   [30.549151, 32.310662],
   [30.567006, 32.305024],
   [30.573949, 32.305024],
   [30.584149, 32.307437],
   [30.615521, 32.32242],
   [30.702928, 32.343279],
   [30.716357, 32.343279],
   [30.72762, 32.340148],
   [30.806851, 32.319086],
   [30.856494, 32.31736],
   [30.882132, 32.316759],
   [30.960774, 32.313773],
   [31.01215, 32.311948],
   [31.098968, 32.309581],
   [31.124555, 32.316018],
   [31.219657, 32.34349],
   [31.277831, 32.356823],
   [31.826953, 31.714357],
   [37.246558, 11.58653],
   [37.44674, 11.11313],
   [37.687752, 8.778707],
   [35.939154, -5.704624],
   [35.877653, -6.170674],
   [36.762514, -9.095293],
   [36.969759, -9.375811],
   [38.659776, -10.015606],
   [43.249448, -9.976372],
   [47.84289, -6.479628],
   [48.864544, -5.660632],
   [49.873662, -3.071187],
   [50.545315, 0.724702],
   [50.99019, 1.480863],
   [52.451839, 3.598474],
   [53.374134, 4.774132],
   [53.435702, 4.857545],
   [53.754149, 6.338944],
   [53.983932, 8.241397],
   [53.944442, 8.628174],
   [53.871762, 8.760262],
   [53.844426, 8.852273],
   [53.875507, 9.108048],
   [53.863158, 9.286919],
   [53.816161, 9.358502],
   [53.752061, 9.413777],
   [53.710019, 9.49154],
   [53.624893, 9.54527],
   [53.571207, 9.662],
   [53.547959, 9.849454],
   [53.55, 9.93333]]},
 {'id': '_Durban->Colombo_',
  'from': 'Durban',
  'to': 'Colombo',
  'distance': 3649.4379049676027,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-29.864237, 31.059373],
   [-29.8526, 31.0637],
   [-25.861671, 47.442961],
   [4.974287, 79.187655],
   [7.002643, 79.763217],
   [6.967749, 79.843912]]},
 {'id': '_Tuticorin->Colombo_',
  'from': 'Tuticorin',
  'to': 'Colombo',
  'distance': 144.82235421166305,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[8.751147, 78.218279],
   [8.554864, 78.424281],
   [7.002643, 79.763217],
   [6.967749, 79.843912]]},
 {'id': '_Shanghai->Colombo_',
  'from': 'Shanghai',
  'to': 'Colombo',
  'distance': 3781.943844492441,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[31.405663, 121.544666],
   [31.296214, 121.77907],
   [30.929499, 122.870677],
   [28.315245, 122.301208],
   [2.296991, 104.802635],
   [1.508694, 104.543718],
   [1.318161, 104.317166],
   [1.135403, 103.735802],
   [1.281086, 103.274421],
   [1.922056, 102.214665],
   [2.618388, 101.378225],
   [5.467016, 98.007266],
   [6.314776, 93.822642],
   [5.632823, 80.496131],
   [5.877048, 80.173169],
   [6.098787, 79.98018],
   [7.002643, 79.763217],
   [6.967749, 79.843912]]},
 {'id': '_Singapore->Colombo_',
  'from': 'Singapore',
  'to': 'Colombo',
  'distance': 1589.6819654427645,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[1.278771, 103.756599],
   [1.272622, 103.748388],
   [1.202515, 103.625522],
   [1.219293, 103.539816],
   [1.281086, 103.274421],
   [1.922056, 102.214665],
   [2.618388, 101.378225],
   [5.467016, 98.007266],
   [6.314776, 93.822642],
   [5.632823, 80.496131],
   [5.877048, 80.173169],
   [6.098787, 79.98018],
   [7.002643, 79.763217],
   [6.967749, 79.843912]]},
 {'id': '_Singapore->Durban_',
  'from': 'Singapore',
  'to': 'Durban',
  'distance': 4887.155507559395,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[1.278771, 103.756599],
   [1.272622, 103.748388],
   [1.202515, 103.625522],
   [1.219293, 103.539816],
   [1.281086, 103.274421],
   [1.922056, 102.214665],
   [2.618388, 101.378225],
   [5.467016, 98.007266],
   [5.983644, 95.259146],
   [5.834626, 94.381107],
   [-25.861671, 47.442961],
   [-29.8526, 31.0637],
   [-29.864237, 31.059373]]},
 {'id': '_Tuticorin->Durban_',
  'from': 'Tuticorin',
  'to': 'Durban',
  'distance': 3703.6657667386607,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[8.751147, 78.218279],
   [8.554864, 78.424281],
   [0.312403, 75.469601],
   [-25.861671, 47.442961],
   [-29.8526, 31.0637],
   [-29.864237, 31.059373]]},
 {'id': '_Durban->Tuticorin_',
  'from': 'Durban',
  'to': 'Tuticorin',
  'distance': 3693.758099352052,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[-29.864237, 31.059373],
   [-29.8526, 31.0637],
   [-25.861671, 47.442961],
   [1.640023, 75.811285],
   [8.554864, 78.424281],
   [8.751147, 78.218279]]},
 {'id': '_Shanghai->Tuticorin_',
  'from': 'Shanghai',
  'to': 'Tuticorin',
  'distance': 3912.04373650108,
  'is_inter_europe': false,
  'is_mixed': false,
  'is_out': true,
  'coords': [[31.405663, 121.544666],
   [31.296214, 121.77907],
   [30.929499, 122.870677],
   [28.315245, 122.301208],
   [2.296991, 104.802635],
   [1.508694, 104.543718],
   [1.318161, 104.317166],
   [1.135403, 103.735802],
   [1.281086, 103.274421],
   [1.922056, 102.214665],
   [2.618388, 101.378225],
   [5.467016, 98.007266],
   [6.314776, 93.822642],
   [5.632823, 80.496131],
   [5.877048, 80.173169],
   [6.098787, 79.98018],
   [8.554864, 78.424281],
   [8.751147, 78.218279]]}
];

/* =========================================================
   FUEL CONFIGURATION
   Conventional fossil fuels used as vessel base fuels.
   Energy normalized to VLSFO-equivalent (LHV basis).
   ========================================================= */

export const fuelConfig = {
  HFO: {
    name: "Heavy Fuel Oil",
    lhv: { value: 40.5, unit: "MJ/kg" },
    density: { value: 0.991, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.000, unit: "tHFOeq/tFuel" },
    cost: { value: 500, unit: "USD/t" },
    co2: { value: 3.716, unit: "tCO2/tFuel" }
  },
  VLSFO: {
    name: "Very Low Sulfur Fuel Oil",
    lhv: { value: 41.0, unit: "MJ/kg" },
    density: { value: 0.94, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.012, unit: "tHFOeq/tFuel" },
    cost: { value: 650, unit: "USD/t" },
    co2: { value: 3.747, unit: "tCO2/tFuel" }
  },
  MGO: {
    name: "Marine Gas Oil",
    lhv: { value: 42.7, unit: "MJ/kg" },
    density: { value: 0.86, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.054, unit: "tHFOeq/tFuel" },
    cost: { value: 850, unit: "USD/t" },
    co2: { value: 3.876, unit: "tCO2/tFuel" }
  },
  LNG: {
    name: "Liquefied Natural Gas",
    lhv: { value: 49.1, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.212, unit: "tHFOeq/tFuel" },
    cost: { value: 700, unit: "USD/t" },
    co2: { value: 4.380, unit: "tCO2/tFuel" }
  },
  Methanol: {
    name: "Methanol",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.491, unit: "tHFOeq/tFuel" },
    cost: { value: 450, unit: "USD/t" },
    co2: { value: 2.053, unit: "tCO2/tFuel" }
  },
  Ammonia: {
    name: "Ammonia",
    lhv: { value: 18.0, unit: "MJ/kg" },
    density: { value: 0.68, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.444, unit: "tHFOeq/tFuel" },
    cost: { value: 900, unit: "USD/t" },
    co2: { value: 2.231, unit: "tCO2/tFuel" }
  },
};


/* =========================================================
   FUEL LIBRARY
   Full pathway database from CSV.

   STRUCTURE RATIONALE
   ───────────────────
   • name        = full pathway string, e.g. "e-LNG (CO2, AEL, PS)"
                   Exact and unambiguous; used in UI and exports.

   • description = human-readable one-liner summarising the
                   production route, shown as a tooltip on the card.

   • tags        = hierarchical classification, up to 6 levels:
       tag1  Category         Blue fuel | E-fuel | Biofuel
       tag2  Fuel type        Ammonia | LNG | Methanol | Diesel | HFO
       tag3  Target product   e-NH3 | bio-LNG | FAME100 | …
       tag4  Electrolysis     AEL | PEM | SOEC           (e-fuels only)
       tag5  Carbon source    CO2 PS | CO2 DAC | CO via RWGS … (e-fuels only)
       tag6  Biofeedstock     biogas | biocrude | biosyngas | VO/UCO | biooil  (biofuels only)

   • cost        = base-case cost (used in all calculations), USD/t
   • costLow     = low-scenario cost, USD/t
   • costHigh    = high-scenario cost, USD/t

   • hfoEquivalentFactor is derived from LHV_fuel / LHV_VLSFO (40.2 MJ/kg),
     expressing tonnes of this fuel equivalent to one tonne of VLSFO.
   ========================================================= */

export const fuelLibrary = [

  /* ── BLUE FUEL ──────────────────────────────────────────── */
  /* Ammonia */
  {
    id: "blue_NH3_blue_H2_N2",
    name: "blue NH3 (blue H2, N2)",
    category: "Blue fuel",
    color: "#9333ea",
    description: "Blue fuel (fossil with CCS).",
    lhv: { value: 18.8, unit: "MJ/kg" },
    density: { value: 0.68, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.4677, unit: "tVLSFOeq/tFuel" },
    cost: { value: 597.02, unit: "USD/t" },
    costLow: 475.69,
    costHigh: 731.32,
    co2: { value: 0.5, unit: "tCO2/tFuel" },
    tags: { tag1: "Blue fuel", tag2: "Ammonia", tag3: "blue NH3" },
  },

  /* ── E-FUEL ──────────────────────────────────────────── */
  /* LNG */
  {
    id: "e_LNG_CO2_AEL_PS",
    name: "e-LNG (CO2, AEL, PS)",
    category: "E-fuel",
    color: "#06b6d4",
    description: "Electrofuel, AEL electrolysis, CO2 PS carbon source.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 2706.32, unit: "USD/t" },
    costLow: 2117.45,
    costHigh: 3346.39,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "LNG", tag3: "e-LNG", tag4: "AEL", tag5: "CO2 PS" },
  },
  {
    id: "e_LNG_CO2_AEL_DAC",
    name: "e-LNG (CO2, AEL, DAC)",
    category: "E-fuel",
    color: "#06b6d4",
    description: "Electrofuel, AEL electrolysis, CO2 DAC carbon source.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 3699.86, unit: "USD/t" },
    costLow: 2877.63,
    costHigh: 4603.05,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "LNG", tag3: "e-LNG", tag4: "AEL", tag5: "CO2 DAC" },
  },
  {
    id: "e_LNG_CO2_PEM_PS",
    name: "e-LNG (CO2, PEM, PS)",
    category: "E-fuel",
    color: "#06b6d4",
    description: "Electrofuel, PEM electrolysis, CO2 PS carbon source.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 3106.59, unit: "USD/t" },
    costLow: 2407.57,
    costHigh: 3874.79,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "LNG", tag3: "e-LNG", tag4: "PEM", tag5: "CO2 PS" },
  },
  {
    id: "e_LNG_CO2_PEM_DAC",
    name: "e-LNG (CO2, PEM, DAC)",
    category: "E-fuel",
    color: "#06b6d4",
    description: "Electrofuel, PEM electrolysis, CO2 DAC carbon source.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 4100.12, unit: "USD/t" },
    costLow: 3167.75,
    costHigh: 5131.45,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "LNG", tag3: "e-LNG", tag4: "PEM", tag5: "CO2 DAC" },
  },
  {
    id: "e_LNG_CO2_SOEC_PS",
    name: "e-LNG (CO2, SOEC, PS)",
    category: "E-fuel",
    color: "#06b6d4",
    description: "Electrofuel, SOEC electrolysis, CO2 PS carbon source.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 4521.88, unit: "USD/t" },
    costLow: 3457.11,
    costHigh: 5704.8,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "LNG", tag3: "e-LNG", tag4: "SOEC", tag5: "CO2 PS" },
  },
  {
    id: "e_LNG_CO2_SOEC_DAC",
    name: "e-LNG (CO2, SOEC, DAC)",
    category: "E-fuel",
    color: "#06b6d4",
    description: "Electrofuel, SOEC electrolysis, CO2 DAC carbon source.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 5515.42, unit: "USD/t" },
    costLow: 4217.29,
    costHigh: 6961.46,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "LNG", tag3: "e-LNG", tag4: "SOEC", tag5: "CO2 DAC" },
  },
  {
    id: "e_LNG_CO_AEL_PS",
    name: "e-LNG (CO, AEL, PS)",
    category: "E-fuel",
    color: "#06b6d4",
    description: "Electrofuel, AEL electrolysis, CO2 PS carbon source.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 2871.41, unit: "USD/t" },
    costLow: 2229.51,
    costHigh: 3570.01,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "LNG", tag3: "e-LNG", tag4: "AEL", tag5: "CO2 PS" },
  },
  {
    id: "e_LNG_CO_AEL_DAC",
    name: "e-LNG (CO, AEL, DAC)",
    category: "E-fuel",
    color: "#06b6d4",
    description: "Electrofuel, AEL electrolysis, CO2 DAC carbon source.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 3874.17, unit: "USD/t" },
    costLow: 2996.75,
    costHigh: 4838.34,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "LNG", tag3: "e-LNG", tag4: "AEL", tag5: "CO2 DAC" },
  },
  {
    id: "e_LNG_CO_PEM_PS",
    name: "e-LNG (CO, PEM, PS)",
    category: "E-fuel",
    color: "#06b6d4",
    description: "Electrofuel, PEM electrolysis, CO2 PS carbon source.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 3271.36, unit: "USD/t" },
    costLow: 2519.41,
    costHigh: 4098.0,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "LNG", tag3: "e-LNG", tag4: "PEM", tag5: "CO2 PS" },
  },
  {
    id: "e_LNG_CO_PEM_DAC",
    name: "e-LNG (CO, PEM, DAC)",
    category: "E-fuel",
    color: "#06b6d4",
    description: "Electrofuel, PEM electrolysis, CO2 DAC carbon source.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 4274.13, unit: "USD/t" },
    costLow: 3286.65,
    costHigh: 5366.34,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "LNG", tag3: "e-LNG", tag4: "PEM", tag5: "CO2 DAC" },
  },
  {
    id: "e_LNG_CO_SOEC_PS",
    name: "e-LNG (CO, SOEC, PS)",
    category: "E-fuel",
    color: "#06b6d4",
    description: "Electrofuel, SOEC electrolysis, CO2 PS carbon source.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 4685.57, unit: "USD/t" },
    costLow: 3568.14,
    costHigh: 5926.61,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "LNG", tag3: "e-LNG", tag4: "SOEC", tag5: "CO2 PS" },
  },
  {
    id: "e_LNG_CO_SOEC_DAC",
    name: "e-LNG (CO, SOEC, DAC)",
    category: "E-fuel",
    color: "#06b6d4",
    description: "Electrofuel, SOEC electrolysis, CO2 DAC carbon source.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 5688.33, unit: "USD/t" },
    costLow: 4335.38,
    costHigh: 7194.94,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "LNG", tag3: "e-LNG", tag4: "SOEC", tag5: "CO2 DAC" },
  },
  /* Ammonia */
  {
    id: "e_NH3_AEL",
    name: "e-NH3 (AEL)",
    category: "E-fuel",
    color: "#a855f7",
    description: "Electrofuel, AEL electrolysis.",
    lhv: { value: 18.8, unit: "MJ/kg" },
    density: { value: 0.68, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.4677, unit: "tVLSFOeq/tFuel" },
    cost: { value: 868.18, unit: "USD/t" },
    costLow: 675.66,
    costHigh: 1077.84,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Ammonia", tag3: "e-NH3", tag4: "AEL" },
  },
  {
    id: "e_NH3_PEM",
    name: "e-NH3 (PEM)",
    category: "E-fuel",
    color: "#a855f7",
    description: "Electrofuel, PEM electrolysis.",
    lhv: { value: 18.8, unit: "MJ/kg" },
    density: { value: 0.68, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.4677, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1006.73, unit: "USD/t" },
    costLow: 776.08,
    costHigh: 1260.75,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Ammonia", tag3: "e-NH3", tag4: "PEM" },
  },
  {
    id: "e_NH3_SOEC",
    name: "e-NH3 (SOEC)",
    category: "E-fuel",
    color: "#a855f7",
    description: "Electrofuel, SOEC electrolysis.",
    lhv: { value: 18.8, unit: "MJ/kg" },
    density: { value: 0.68, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.4677, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1496.64, unit: "USD/t" },
    costLow: 1139.39,
    costHigh: 1894.21,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Ammonia", tag3: "e-NH3", tag4: "SOEC" },
  },
  /* Methanol */
  {
    id: "e_MeOH_CO2_AEL_PS",
    name: "e-MeOH (CO2, AEL, PS)",
    category: "E-fuel",
    color: "#8b5cf6",
    description: "Electrofuel, AEL electrolysis, CO2 PS carbon source.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1090.61, unit: "USD/t" },
    costLow: 846.38,
    costHigh: 1355.7,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Methanol", tag3: "e-MeOH (direct)", tag4: "AEL", tag5: "CO2 PS" },
  },
  {
    id: "e_MeOH_CO2_AEL_DAC",
    name: "e-MeOH (CO2, AEL, DAC)",
    category: "E-fuel",
    color: "#8b5cf6",
    description: "Electrofuel, AEL electrolysis, CO2 DAC carbon source.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1576.73, unit: "USD/t" },
    costLow: 1218.33,
    costHigh: 1970.57,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Methanol", tag3: "e-MeOH (direct)", tag4: "AEL", tag5: "CO2 DAC" },
  },
  {
    id: "e_MeOH_CO2_PEM_PS",
    name: "e-MeOH (CO2, PEM, PS)",
    category: "E-fuel",
    color: "#8b5cf6",
    description: "Electrofuel, PEM electrolysis, CO2 PS carbon source.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1236.86, unit: "USD/t" },
    costLow: 952.39,
    costHigh: 1548.77,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Methanol", tag3: "e-MeOH (direct)", tag4: "PEM", tag5: "CO2 PS" },
  },
  {
    id: "e_MeOH_CO2_PEM_DAC",
    name: "e-MeOH (CO2, PEM, DAC)",
    category: "E-fuel",
    color: "#8b5cf6",
    description: "Electrofuel, PEM electrolysis, CO2 DAC carbon source.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1722.98, unit: "USD/t" },
    costLow: 1324.33,
    costHigh: 2163.64,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Methanol", tag3: "e-MeOH (direct)", tag4: "PEM", tag5: "CO2 DAC" },
  },
  {
    id: "e_MeOH_CO2_SOEC_PS",
    name: "e-MeOH (CO2, SOEC, PS)",
    category: "E-fuel",
    color: "#8b5cf6",
    description: "Electrofuel, SOEC electrolysis, CO2 PS carbon source.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1753.99, unit: "USD/t" },
    costLow: 1335.87,
    costHigh: 2217.43,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Methanol", tag3: "e-MeOH (direct)", tag4: "SOEC", tag5: "CO2 PS" },
  },
  {
    id: "e_MeOH_CO2_SOEC_DAC",
    name: "e-MeOH (CO2, SOEC, DAC)",
    category: "E-fuel",
    color: "#8b5cf6",
    description: "Electrofuel, SOEC electrolysis, CO2 DAC carbon source.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 2240.11, unit: "USD/t" },
    costLow: 1707.82,
    costHigh: 2832.3,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Methanol", tag3: "e-MeOH (direct)", tag4: "SOEC", tag5: "CO2 DAC" },
  },
  {
    id: "e_MeOH_CO_AEL_PS",
    name: "e-MeOH (CO, AEL, PS)",
    category: "E-fuel",
    color: "#8b5cf6",
    description: "Electrofuel, AEL electrolysis, CO via RWGS CO2 PS carbon source.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1118.66, unit: "USD/t" },
    costLow: 866.45,
    costHigh: 1392.84,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Methanol", tag3: "e-MeOH (RWGS)", tag4: "AEL", tag5: "CO via RWGS CO2 PS" },
  },
  {
    id: "e_MeOH_CO_AEL_DAC",
    name: "e-MeOH (CO, AEL, DAC)",
    category: "E-fuel",
    color: "#8b5cf6",
    description: "Electrofuel, AEL electrolysis, CO via RWGS CO2 DAC carbon source.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1614.48, unit: "USD/t" },
    costLow: 1245.81,
    costHigh: 2019.96,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Methanol", tag3: "e-MeOH (RWGS)", tag4: "AEL", tag5: "CO via RWGS CO2 DAC" },
  },
  {
    id: "e_MeOH_CO_PEM_PS",
    name: "e-MeOH (CO, PEM, PS)",
    category: "E-fuel",
    color: "#8b5cf6",
    description: "Electrofuel, PEM electrolysis, CO via RWGS CO2 PS carbon source.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1268.05, unit: "USD/t" },
    costLow: 974.73,
    costHigh: 1590.05,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Methanol", tag3: "e-MeOH (RWGS)", tag4: "PEM", tag5: "CO via RWGS CO2 PS" },
  },
  {
    id: "e_MeOH_CO_PEM_DAC",
    name: "e-MeOH (CO, PEM, DAC)",
    category: "E-fuel",
    color: "#8b5cf6",
    description: "Electrofuel, PEM electrolysis, CO via RWGS CO2 DAC carbon source.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1763.87, unit: "USD/t" },
    costLow: 1354.09,
    costHigh: 2217.17,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Methanol", tag3: "e-MeOH (RWGS)", tag4: "PEM", tag5: "CO via RWGS CO2 DAC" },
  },
  {
    id: "e_MeOH_CO_SOEC_PS",
    name: "e-MeOH (CO, SOEC, PS)",
    category: "E-fuel",
    color: "#8b5cf6",
    description: "Electrofuel, SOEC electrolysis, CO via RWGS CO2 PS carbon source.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1796.29, unit: "USD/t" },
    costLow: 1366.45,
    costHigh: 2273.07,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Methanol", tag3: "e-MeOH (RWGS)", tag4: "SOEC", tag5: "CO via RWGS CO2 PS" },
  },
  {
    id: "e_MeOH_CO_SOEC_DAC",
    name: "e-MeOH (CO, SOEC, DAC)",
    category: "E-fuel",
    color: "#8b5cf6",
    description: "Electrofuel, SOEC electrolysis, CO via RWGS CO2 DAC carbon source.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 2292.1, unit: "USD/t" },
    costLow: 1745.81,
    costHigh: 2900.19,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Methanol", tag3: "e-MeOH (RWGS)", tag4: "SOEC", tag5: "CO via RWGS CO2 DAC" },
  },
  /* Diesel */
  {
    id: "e_Diesel_AEL_PS",
    name: "e-Diesel (AEL, PS)",
    category: "E-fuel",
    color: "#e879f9",
    description: "Electrofuel, AEL electrolysis, CO2 PS carbon source.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 3596.25, unit: "USD/t" },
    costLow: 2786.59,
    costHigh: 4477.26,
    co2: { value: 0.04, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Diesel", tag3: "e-diesel", tag4: "AEL", tag5: "CO2 PS" },
  },
  {
    id: "e_Diesel_AEL_DAC",
    name: "e-Diesel (AEL, DAC)",
    category: "E-fuel",
    color: "#e879f9",
    description: "Electrofuel, AEL electrolysis, CO2 DAC carbon source.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 5128.25, unit: "USD/t" },
    costLow: 3958.76,
    costHigh: 6414.99,
    co2: { value: 0.04, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Diesel", tag3: "e-diesel", tag4: "AEL", tag5: "CO2 DAC" },
  },
  {
    id: "e_Diesel_PEM_PS",
    name: "e-Diesel (PEM, PS)",
    category: "E-fuel",
    color: "#e879f9",
    description: "Electrofuel, PEM electrolysis, CO2 PS carbon source.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 4087.34, unit: "USD/t" },
    costLow: 3142.55,
    costHigh: 5125.56,
    co2: { value: 0.04, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Diesel", tag3: "e-diesel", tag4: "PEM", tag5: "CO2 PS" },
  },
  {
    id: "e_Diesel_PEM_DAC",
    name: "e-Diesel (PEM, DAC)",
    category: "E-fuel",
    color: "#e879f9",
    description: "Electrofuel, PEM electrolysis, CO2 DAC carbon source.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 5619.34, unit: "USD/t" },
    costLow: 4314.71,
    costHigh: 7063.29,
    co2: { value: 0.04, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Diesel", tag3: "e-diesel", tag4: "PEM", tag5: "CO2 DAC" },
  },
  {
    id: "e_Diesel_SOEC_PS",
    name: "e-Diesel (SOEC, PS)",
    category: "E-fuel",
    color: "#e879f9",
    description: "Electrofuel, SOEC electrolysis, CO2 PS carbon source.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 5823.8, unit: "USD/t" },
    costLow: 4430.26,
    costHigh: 7370.84,
    co2: { value: 0.04, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Diesel", tag3: "e-diesel", tag4: "SOEC", tag5: "CO2 PS" },
  },
  {
    id: "e_Diesel_SOEC_DAC",
    name: "e-Diesel (SOEC, DAC)",
    category: "E-fuel",
    color: "#e879f9",
    description: "Electrofuel, SOEC electrolysis, CO2 DAC carbon source.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 7355.8, unit: "USD/t" },
    costLow: 5602.42,
    costHigh: 9308.58,
    co2: { value: 0.04, unit: "tCO2/tFuel" },
    tags: { tag1: "E-fuel", tag2: "Diesel", tag3: "e-diesel", tag4: "SOEC", tag5: "CO2 DAC" },
  },

  /* ── BIOFUEL ──────────────────────────────────────────── */
  /* LNG */
  {
    id: "bio_LNG_AD_Manure",
    name: "bio-LNG (AD, Manure)",
    category: "Biofuel",
    color: "#22d3ee",
    description: "Biofuel, from biogas.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1554.11, unit: "USD/t" },
    costLow: 1169.96,
    costHigh: 1999.0,
    co2: { value: -5.36, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "LNG", tag3: "bio-LNG", tag6: "biogas" },
  },
  {
    id: "bio_LNG_AD_SewageSludge",
    name: "bio-LNG (AD, SewageSludge)",
    category: "Biofuel",
    color: "#22d3ee",
    description: "Biofuel, from biogas.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1540.61, unit: "USD/t" },
    costLow: 1197.36,
    costHigh: 1937.28,
    co2: { value: -0.35, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "LNG", tag3: "bio-LNG", tag6: "biogas" },
  },
  {
    id: "bio_LNG_AD_MSW",
    name: "bio-LNG (AD, MSW)",
    category: "Biofuel",
    color: "#22d3ee",
    description: "Biofuel, from biogas.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 2431.6, unit: "USD/t" },
    costLow: 1844.76,
    costHigh: 3100.52,
    co2: { value: -1.1, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "LNG", tag3: "bio-LNG", tag6: "biogas" },
  },
  {
    id: "bio_LNG_AD_AgriResidues",
    name: "bio-LNG (AD, AgriResidues)",
    category: "Biofuel",
    color: "#22d3ee",
    description: "Biofuel, from biogas.",
    lhv: { value: 48.6, unit: "MJ/kg" },
    density: { value: 0.45, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 3125.66, unit: "USD/t" },
    costLow: 2409.46,
    costHigh: 3916.95,
    co2: { value: 0.26, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "LNG", tag3: "bio-LNG", tag6: "biogas" },
  },
  /* HFO */
  {
    id: "bio_HFO_biooil",
    name: "bio-HFO (biooil)",
    category: "Biofuel",
    color: "#86efac",
    description: "Biofuel, from biooil.",
    lhv: { value: 17.0, unit: "MJ/kg" },
    density: { value: 0.99, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.4229, unit: "tVLSFOeq/tFuel" },
    cost: { value: 864.69, unit: "USD/t" },
    costLow: 675.41,
    costHigh: 1070.98,
    co2: { value: 0.12, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "HFO", tag3: "bio-HFO", tag6: "biooil" },
  },
  {
    id: "bio_HFO_biocrude_SewageSludge",
    name: "bio-HFO (biocrude, SewageSludge)",
    category: "Biofuel",
    color: "#86efac",
    description: "Biofuel, from biocrude.",
    lhv: { value: 33.0, unit: "MJ/kg" },
    density: { value: 0.99, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.8209, unit: "tVLSFOeq/tFuel" },
    cost: { value: 774.89, unit: "USD/t" },
    costLow: 628.91,
    costHigh: 937.87,
    co2: { value: -0.66, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "HFO", tag3: "bio-HFO", tag6: "biocrude" },
  },
  {
    id: "bio_HFO_biocrude_Algae",
    name: "bio-HFO (biocrude, Algae)",
    category: "Biofuel",
    color: "#86efac",
    description: "Biofuel, from biocrude.",
    lhv: { value: 36.0, unit: "MJ/kg" },
    density: { value: 0.99, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.8955, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1050.72, unit: "USD/t" },
    costLow: 833.79,
    costHigh: 1283.86,
    co2: { value: -0.2, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "HFO", tag3: "bio-HFO", tag6: "biocrude" },
  },
  {
    id: "bio_HFO_biocrude_Wood",
    name: "bio-HFO (biocrude, Wood)",
    category: "Biofuel",
    color: "#86efac",
    description: "Biofuel, from biocrude.",
    lhv: { value: 31.0, unit: "MJ/kg" },
    density: { value: 0.99, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.7711, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1009.46, unit: "USD/t" },
    costLow: 804.42,
    costHigh: 1232.31,
    co2: { value: -0.48, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "HFO", tag3: "bio-HFO", tag6: "biocrude" },
  },
  /* Diesel */
  {
    id: "biodiesel_biocrude_SewageSludge",
    name: "biodiesel (biocrude, SewageSludge)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from biocrude.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1307.44, unit: "USD/t" },
    costLow: 1051.26,
    costHigh: 1593.25,
    co2: { value: -0.82, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "biodiesel", tag6: "biocrude" },
  },
  {
    id: "biodiesel_biocrude_Algae",
    name: "biodiesel (biocrude, Algae)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from biocrude.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1645.95, unit: "USD/t" },
    costLow: 1302.7,
    costHigh: 2017.88,
    co2: { value: -0.25, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "biodiesel", tag6: "biocrude" },
  },
  {
    id: "biodiesel_biocrude_Wood",
    name: "biodiesel (biocrude, Wood)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from biocrude.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1595.32, unit: "USD/t" },
    costLow: 1266.65,
    costHigh: 1954.6,
    co2: { value: -0.6, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "biodiesel", tag6: "biocrude" },
  },
  {
    id: "biodiesel_biosyngas",
    name: "biodiesel (biosyngas)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from biosyngas.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 2025.6, unit: "USD/t" },
    costLow: 1559.38,
    costHigh: 2542.6,
    co2: { value: 0.47, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "biodiesel", tag6: "biosyngas" },
  },
  {
    id: "FAME_VOclean_bio_MeOH_AD_Manure",
    name: "FAME (VOclean, bio-MeOH-AD-Manure)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from VO/UCO.",
    lhv: { value: 37.2, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.9254, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1237.63, unit: "USD/t" },
    costLow: 983.78,
    costHigh: 1498.81,
    co2: { value: -0.5, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "FAME100", tag6: "VO/UCO" },
  },
  {
    id: "FAME_VOclean_bio_MeOH_AD_SewageSludge",
    name: "FAME (VOclean, bio-MeOH-AD-SewageSludge)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from VO/UCO.",
    lhv: { value: 37.2, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.9254, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1241.19, unit: "USD/t" },
    costLow: 990.32,
    costHigh: 1498.82,
    co2: { value: -0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "FAME100", tag6: "VO/UCO" },
  },
  {
    id: "FAME_VOclean_bio_MeOH_AD_MSW",
    name: "FAME (VOclean, bio-MeOH-AD-MSW)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from VO/UCO.",
    lhv: { value: 37.2, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.9254, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1317.64, unit: "USD/t" },
    costLow: 1045.77,
    costHigh: 1598.7,
    co2: { value: -0.08, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "FAME100", tag6: "VO/UCO" },
  },
  {
    id: "FAME_VOclean_bio_MeOH_AD_AgriResidues",
    name: "FAME (VOclean, bio-MeOH-AD-AgriResidues)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from VO/UCO.",
    lhv: { value: 37.2, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.9254, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1344.26, unit: "USD/t" },
    costLow: 1068.61,
    costHigh: 1627.72,
    co2: { value: 0.04, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "FAME100", tag6: "VO/UCO" },
  },
  {
    id: "HVO_VOclean_bio_H2_AD_Manure",
    name: "HVO (VOclean, bio-H2-AD-Manure)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from VO/UCO.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1590.95, unit: "USD/t" },
    costLow: 1255.05,
    costHigh: 1941.87,
    co2: { value: -0.74, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "HVO100", tag6: "VO/UCO" },
  },
  {
    id: "HVO_VOclean_bio_H2_AD_SewageSludge",
    name: "HVO (VOclean, bio-H2-AD-SewageSludge)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from VO/UCO.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1588.91, unit: "USD/t" },
    costLow: 1259.19,
    costHigh: 1932.54,
    co2: { value: 0.02, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "HVO100", tag6: "VO/UCO" },
  },
  {
    id: "HVO_VOclean_bio_H2_AD_MSW",
    name: "HVO (VOclean, bio-H2-AD-MSW)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from VO/UCO.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1723.63, unit: "USD/t" },
    costLow: 1357.08,
    costHigh: 2108.42,
    co2: { value: -0.09, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "HVO100", tag6: "VO/UCO" },
  },
  {
    id: "HVO_VOclean_bio_H2_AD_AgriResidues",
    name: "HVO (VOclean, bio-H2-AD-AgriResidues)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from VO/UCO.",
    lhv: { value: 44.0, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0945, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1828.57, unit: "USD/t" },
    costLow: 1442.46,
    costHigh: 2231.86,
    co2: { value: 0.11, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "HVO100", tag6: "VO/UCO" },
  },
  {
    id: "FAME20_HVO80_VOclean_bio_H2_MeOH_AD_Manure",
    name: "FAME20/HVO80 (VOclean, bio-H2/MeOH-AD-Manure)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from VO/UCO.",
    lhv: { value: 42.64, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0607, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1525.59, unit: "USD/t" },
    costLow: 1205.34,
    costHigh: 1859.43,
    co2: { value: -0.69, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "FAME20/HVO80", tag6: "VO/UCO" },
  },
  {
    id: "FAME20_HVO80_VOclean_bio_H2_MeOH_AD_SewageSludge",
    name: "FAME20/HVO80 (VOclean, bio-H2/MeOH-AD-SewageSludge)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from VO/UCO.",
    lhv: { value: 42.64, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0607, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1524.89, unit: "USD/t" },
    costLow: 1210.14,
    costHigh: 1852.24,
    co2: { value: 0.01, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "FAME20/HVO80", tag6: "VO/UCO" },
  },
  {
    id: "FAME20_HVO80_VOclean_bio_H2_MeOH_AD_MSW",
    name: "FAME20/HVO80 (VOclean, bio-H2/MeOH-AD-MSW)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from VO/UCO.",
    lhv: { value: 42.64, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0607, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1647.96, unit: "USD/t" },
    costLow: 1299.54,
    costHigh: 2012.92,
    co2: { value: -0.09, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "FAME20/HVO80", tag6: "VO/UCO" },
  },
  {
    id: "FAME20_HVO80_VOclean_bio_H2_MeOH_AD_AgriResidues",
    name: "FAME20/HVO80 (VOclean, bio-H2/MeOH-AD-AgriResidues)",
    category: "Biofuel",
    color: "#4ade80",
    description: "Biofuel, from VO/UCO.",
    lhv: { value: 42.64, unit: "MJ/kg" },
    density: { value: 0.84, unit: "t/m3" },
    hfoEquivalentFactor: { value: 1.0607, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1737.24, unit: "USD/t" },
    costLow: 1372.42,
    costHigh: 2117.48,
    co2: { value: 0.1, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Diesel", tag3: "FAME20/HVO80", tag6: "VO/UCO" },
  },
  /* Ammonia */
  {
    id: "bio_NH3_bio_H2_biosyngas_N2",
    name: "bio-NH3 (bio-H2, biosyngas, N2)",
    category: "Biofuel",
    color: "#c084fc",
    description: "Biofuel, from biosyngas.",
    lhv: { value: 18.8, unit: "MJ/kg" },
    density: { value: 0.68, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.4677, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1750.36, unit: "USD/t" },
    costLow: 1364.78,
    costHigh: 2175.59,
    co2: { value: 0.3, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Ammonia", tag3: "bio-NH3", tag6: "biosyngas" },
  },
  {
    id: "bio_NH3_bio_H2_AD_Manure_SMR_N2",
    name: "bio-NH3 (bio-H2 AD-Manure-SMR, N2)",
    category: "Biofuel",
    color: "#c084fc",
    description: "Biofuel, from biogas.",
    lhv: { value: 18.8, unit: "MJ/kg" },
    density: { value: 0.68, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.4677, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1004.1, unit: "USD/t" },
    costLow: 755.41,
    costHigh: 1291.92,
    co2: { value: -3.51, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Ammonia", tag3: "bio-NH3", tag6: "biogas" },
  },
  {
    id: "bio_NH3_bio_H2_AD_SewageSludge_SMR_N2",
    name: "bio-NH3 (bio-H2 AD-SewageSludge-SMR, N2)",
    category: "Biofuel",
    color: "#c084fc",
    description: "Biofuel, from biogas.",
    lhv: { value: 18.8, unit: "MJ/kg" },
    density: { value: 0.68, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.4677, unit: "tVLSFOeq/tFuel" },
    cost: { value: 995.35, unit: "USD/t" },
    costLow: 773.17,
    costHigh: 1251.93,
    co2: { value: -0.27, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Ammonia", tag3: "bio-NH3", tag6: "biogas" },
  },
  {
    id: "bio_NH3_bio_H2_AD_MSW_SMR_N2",
    name: "bio-NH3 (bio-H2 AD-MSW-SMR, N2)",
    category: "Biofuel",
    color: "#c084fc",
    description: "Biofuel, from biogas.",
    lhv: { value: 18.8, unit: "MJ/kg" },
    density: { value: 0.68, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.4677, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1572.72, unit: "USD/t" },
    costLow: 1192.68,
    costHigh: 2005.71,
    co2: { value: -0.75, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Ammonia", tag3: "bio-NH3", tag6: "biogas" },
  },
  {
    id: "bio_NH3_bio_H2_AD_AgriResidues_SMR_N2",
    name: "bio-NH3 (bio-H2 AD-AgriResidues-SMR, N2)",
    category: "Biofuel",
    color: "#c084fc",
    description: "Biofuel, from biogas.",
    lhv: { value: 18.8, unit: "MJ/kg" },
    density: { value: 0.68, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.4677, unit: "tVLSFOeq/tFuel" },
    cost: { value: 2022.47, unit: "USD/t" },
    costLow: 1558.6,
    costHigh: 2534.76,
    co2: { value: 0.13, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Ammonia", tag3: "bio-NH3", tag6: "biogas" },
  },
  /* Methanol */
  {
    id: "bio_MeOH_biogas_AD_Manure",
    name: "bio-MeOH (biogas, AD, Manure)",
    category: "Biofuel",
    color: "#a78bfa",
    description: "Biofuel, from biogas.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1138.93, unit: "USD/t" },
    costLow: 850.07,
    costHigh: 1473.8,
    co2: { value: -4.79, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Methanol", tag3: "bio-MeOH", tag6: "biogas" },
  },
  {
    id: "bio_MeOH_biogas_AD_SewageSludge",
    name: "bio-MeOH (biogas, AD, SewageSludge)",
    category: "Biofuel",
    color: "#a78bfa",
    description: "Biofuel, from biogas.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1171.36, unit: "USD/t" },
    costLow: 909.46,
    costHigh: 1473.86,
    co2: { value: -0.37, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Methanol", tag3: "bio-MeOH", tag6: "biogas" },
  },
  {
    id: "bio_MeOH_biogas_AD_MSW",
    name: "bio-MeOH (biogas, AD, MSW)",
    category: "Biofuel",
    color: "#a78bfa",
    description: "Biofuel, from biogas.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1866.3, unit: "USD/t" },
    costLow: 1413.59,
    costHigh: 2381.89,
    co2: { value: -0.97, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Methanol", tag3: "bio-MeOH", tag6: "biogas" },
  },
  {
    id: "bio_MeOH_biogas_AD_AgriResidues",
    name: "bio-MeOH (biogas, AD, AgriResidues)",
    category: "Biofuel",
    color: "#a78bfa",
    description: "Biofuel, from biogas.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 2108.37, unit: "USD/t" },
    costLow: 1621.23,
    costHigh: 2645.68,
    co2: { value: 0.11, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Methanol", tag3: "bio-MeOH", tag6: "biogas" },
  },
  {
    id: "bio_MeOH_biosyngas",
    name: "bio-MeOH (biosyngas)",
    category: "Biofuel",
    color: "#a78bfa",
    description: "Biofuel, from biosyngas.",
    lhv: { value: 19.9, unit: "MJ/kg" },
    density: { value: 0.79, unit: "t/m3" },
    hfoEquivalentFactor: { value: 0.495, unit: "tVLSFOeq/tFuel" },
    cost: { value: 1189.59, unit: "USD/t" },
    costLow: 922.34,
    costHigh: 1485.74,
    co2: { value: 0.29, unit: "tCO2/tFuel" },
    tags: { tag1: "Biofuel", tag2: "Methanol", tag3: "bio-MeOH", tag6: "biosyngas" },
  },];

/* Default active fuel IDs (map to fuelConfig keys) */
export const DEFAULT_ACTIVE_FUEL_IDS = Object.keys(fuelConfig);

export const SCENARIO_YEARS = [
  2025,
  2030,
  2035,
  2040,
  2045,
  2050
];

export const EU_MARITIME_FACTORS = {
  inter: 1.0,
  mixed: 0.5,
  out: 0.0,
  hfoLhvMJperT: 41000,
  yearlyTargets: {
    2025: 89.34,
    2030: 85.69,
    2035: 77.94,
    2040: 62.90,
    2045: 34.64,
    2050: 18.23,
  }
};